export const nl = {
  app: {
    title: "Arch-designer",
    tagline:
      "Modelleer samen in één repository: ArchiMate 4, C4, Sharp en meer. Elk diagram is een weergave op hetzelfde model.",
    status: {
      title: "Verbinding met API",
      loading: "Bezig met laden…",
      error: "Fout",
      superAdminNoWorkspace:
        "Je bent super admin maar (nog) geen lid van een workspace. Open ⚙ Instellingen → Workspace → Wissel workspace om er een te kiezen.",
      user: "Ingelogd als",
      language: "UI-taal",
      workspaces: "Workspaces",
    },
    header: {
      settings: "⚙ Instellingen",
      settingsTitle: "Instellingen (F10)",
      settingsMenu: "⚙ Instellingen",
      settingsMenuTitle: "Instellingen-menu openen (F10)",
      sourceCode: "Broncode (AGPL-3.0)",
      readOnly: "Alleen lezen",
      readOnlyTitle:
        "Je hebt leesrecht op dit workpackage: je kunt kijken, maar niets wijzigen. Schrijfrecht vraag je aan een workspace-admin.",
      settingsMenuGeneralGroup: "Algemeen",
      settingsMenuInstallGroup: "Installatie",
      settingsMenuAdminGroup: "Beheer",
      settingsMenuPending: "Nog niet gewired in dropdown — gebruik de oude Settings-knop",
      logoutAs: "Uitloggen ({{email}})",
      logoutTitle: "Uitloggen",
      displayModeV31: "3.x",
      displayModeV31Title:
        "ArchiMate 3.x-weergave — toont de vertrouwde laag-specifieke types (Bedrijfsproces, Applicatieservice, …). Alleen presentatie; het model verandert niet.",
      displayModeV4: "4",
      displayModeV4Title:
        "ArchiMate 4-weergave — toont de generieke types (Proces, Service, …) met de 3.x-herkomst als «stereotype»-badge. Alleen presentatie; het model verandert niet.",
      chooseWorkspace: "Kies workspace",
      scopeIndicatorTitle: "Actieve focus-scope (F7 om te wisselen)",
      crdt: {
        connecting: "verbinden…",
        connectingTitle: "Bezig met verbinden met de realtime-server",
        syncing: "synchroniseren…",
        syncingTitle: "Initiële sync met de andere editors loopt",
        connected: "live",
        connectedTitle: "Verbonden — wijzigingen van anderen verschijnen vanzelf",
        offline: "offline",
        offlineTitle: "Geen verbinding met de realtime-server — opnieuw proberen…",
      },
    },
    panels: {
      explorer: "Explorer",
      concepts: "Concepten",
      types: "Types",
      diagrams: "Diagrammen",
      relations: "Relaties",
      openPanelTitle: "{{label}}-paneel openen",
      resizeHandleTitle:
        "Sleep om breedte aan te passen — dubbelklik om naar standaard te resetten",
    },
    kladblok: {
      hint: "Kladblok — sleep concepten hier vanaf de Foldertree",
      clear: "Leegmaken",
      clearTitle: "Kladblok leegmaken (concepten + relaties blijven in DB)",
      conceptNotFound: "Concept '{{conceptId}}' niet gevonden in workspace-store.",
      endpointsNotFound: "Bron- of doel-concept niet (meer) in workspace-store gevonden.",
      createRelationFailed: "Relatie aanmaken mislukt: {{msg}}",
      dismiss: "sluit",
      dismissAria: "Sluit",
      picker: {
        title: "Kies relatie-type",
        noneBefore: "Geen geldige relatie-types tussen",
        noneAnd: "en",
        noneAfter: "volgens de matrix.",
        reversed: "{{label}} (omgekeerd)",
      },
    },
    editor: {
      fixNestedDone: "Fix: {{n}} concept(en) gekoppeld aan hun container.",
      fixNestedNone: "Fix: geen nesting-correcties nodig op dit diagram.",
    },
  },
  ribbon: {
    groups: {
      font: "Lettertype/tekst uitlijnen",
      colour: "Kleur",
      align: "Uitlijnen objecten",
      textInObject: "Tekst in object",
      size: "Grootte",
      line: "Lijn",
      zStack: "z-volgorde",
      overlay: "Overlay",
    },
    groupsShort: {
      font: "Tekst",
      colour: "Kleur",
      align: "Uitlijnen",
      zStack: "Volgorde",
      textInObject: "Tekstpositie",
      size: "Grootte",
      line: "Lijn",
      overlay: "Overlay",
    },
    bold: "Vet",
    italic: "Cursief",
    underline: "Onderstreept",
    fontFamily: "Lettertype",
    fontSize: "Lettergrootte",
    textColour: "Tekstkleur",
    fillColour: "Achtergrondkleur",
    lineColour: "Lijnkleur",
    labelVertical: "Tekst een kwartslag draaien",
    clearFormatting: "Opmaak wissen",
    alignLeft: "Links uitlijnen",
    alignCenter: "Gecentreerd",
    alignCenterX: "Horizontaal centreren",
    alignRight: "Rechts uitlijnen",
    labelWrapHyphenate: "Woord afbreken met streepje (lettergreep-niveau)",
    labelWrapBreakAnywhere: "Woord afbreken midden in het woord",
    alignTop: "Boven uitlijnen",
    alignCenterY: "Verticaal centreren",
    alignBottom: "Onder uitlijnen",
    label: {
      topLeft: "Linksboven",
      top: "Boven",
      topRight: "Rechtsboven",
      left: "Links",
      center: "Centreren",
      right: "Rechts",
      bottomLeft: "Linksonder",
      bottom: "Onder",
      bottomRight: "Rechtsonder",
      outside: "buiten",
      outsideSuffix: " (buiten)",
      outsideTitle: "Buiten — label aan de buitenkant in de gekozen richting",
      hideIconTitle: "Verberg het type-icoon rechtsboven op de geselecteerde objecten",
      hideIcon: "Verberg icoon",
    },
    equalWidth: "Gelijke breedte",
    equalHeight: "Gelijke hoogte",
    equalBoth: "Gelijke breedte en hoogte",
    shapeEllipse: "Ellips / cirkel (border-radius 50%) — toggle",
    shapeCircle: "Maak cirkel (vierkant + border-radius 50%)",
    shapeSquare: "Maak vierkant",
    zStack: {
      forward: "Naar voren",
      backward: "Naar achteren",
      toFront: "Helemaal bovenop",
      toBack: "Helemaal onderop",
    },
    orthogonalize:
      "Lijn rechttrekken — elk segment wordt perfect H of V op basis van zijn huidige richting",
    swatch: {
      defaultLabel: "Standaard (uit thema)",
      transparent: "Transparant",
      themeLight: "ArchiMate-laag (licht)",
      themeDark: "ArchiMate-laag (donker)",
      standardColours: "Standaardkleuren",
      recent: "Recent",
      moreColours: "Meer kleuren…",
      eyedropperTitle: "Pak een kleur ergens op het scherm",
      eyedropper: "Pak kleur van scherm",
    },
    default: "Standaard",
    straightenNoHorizontalOverlap:
      "Lijn rechttrekken kan niet — bron en doel overlappen niet horizontaal.",
    straightenNoVerticalOverlap:
      "Lijn rechttrekken kan niet — bron en doel overlappen niet verticaal.",
    strokeColourPicker: "Lijnkleur (rand van het object)",
    strokeColourTitle: "Lijnkleur — rand van geselecteerde object(en)",
    lineColourMulti: "Lijnkleur — toepassen op {{n}} lijnen",
    labelBg: {
      title: "Label-achtergrond",
      multi: "Label-achtergrond — toepassen op {{n}} lijnen",
      set: "Label-achtergrond — klik om te wissen of een andere kleur te kiezen",
      unset: "Label-achtergrond — standaard transparant; kies een kleur voor een opake box",
    },
    labelText: {
      title: "Label-tekstkleur",
      multi: "Label-tekstkleur — toepassen op {{n}} lijnen",
      set: "Label-tekstkleur — klik om te wissen of een andere kleur te kiezen",
      unset: "Label-tekstkleur — standaard slate; kies een kleur voor accent",
    },
    routing: {
      multi: "Routing — toepassen op {{n}} lijnen",
      single: "Routing van de geselecteerde lijn",
      manual: "Handmatig",
    },
    lineStyle: {
      multi: "Lijnstijl — toepassen op {{n}} lijnen",
      single: "Lijnstijl van de geselecteerde lijn",
      borderMulti: "Border-stijl — toepassen op {{n}} concepten",
      borderSingle: "Border-stijl van het geselecteerde concept",
      solid: "— Doorlopend",
      dashed: "- - Streep",
      dotted: "··· Stippels",
      none: "Geen (onzichtbaar)",
    },
    helpTitle: "Open de gebruikershandleiding (Cmd/Ctrl+/)",
    formatPainter: {
      noFormat:
        "Selecteer eerst een object met opmaak (vulling, randkleur, lijnstijl) voordat je de toverstaf gebruikt.",
      armed:
        "Toverstaf actief — selecteer doel-objecten en klik nogmaals om de opmaak toe te passen. Klik zonder selectie om te annuleren.",
      idle: "Toverstaf — selecteer eerst een bron-object met de gewenste opmaak en klik dan hier; selecteer daarna doel-objecten en klik opnieuw.",
    },
  },
  overlay: {
    title: "Kleur-overlay",
    toolbarTitle: "Kleur-overlay (regels op attribuut/type)",
    close: "Sluiten",
    edit: "Bewerken",
    delete: "Verwijderen",
    cancel: "Annuleren",
    save: "Opslaan",
    noDiagram: "Geen diagram geopend.",
    customRenderNote:
      "Dit diagramtype heeft een eigen weergave — de overlay werkt alleen op standaard-diagrammen.",
    enable: "Overlay aan",
    strategy: "Bij meerdere:",
    firstMatch: "eerste regel wint",
    lastMatch: "laatste regel wint",
    noRules: "Nog geen regels. Voeg er één toe om te kleuren of dimmen.",
    ruleEnabled: "Regel actief",
    moveUp: "Regel omhoog (hogere voorrang)",
    moveDown: "Regel omlaag",
    unnamedRule: "(naamloze regel)",
    addRule: "Regel toevoegen",
    clear: "Wis overlay",
    ruleCount: "{{count}} regel(s)",
    condition: "Voorwaarde",
    anyType: "Elk type",
    anyStereotype: "Elk stereotype",
    anyLayer: "Elke laag",
    anyMatch: "elk element",
    labelPlaceholder: "Naam (bijv. Uitgefaseerde apps)",
    attrNamePlaceholder: "Attribuutnaam (optioneel)",
    attrNone: "— geen attribuut —",
    pickValue: "Kies waarde…",
    hasAttrType: "Heeft attribuuttype",
    childNone: "— geen attribuuttype —",
    relatedTo: "Heeft een relatie met (naam)",
    relatedToPlaceholder: "bijv. Partij",
    relatedToShort: "relatie met",
    aiPlaceholder:
      'Beschrijf in taal, bijv. "kleur uitgefaseerde applicaties rood en dim de technologielaag"',
    aiGenerate: "Genereer met AI",
    aiBusy: "Bezig…",
    aiAdded: "{{count}} regel(s) toegevoegd",
    aiNoRules:
      "Geen bruikbare regels uit je beschrijving. Formuleer concreter met bestaande typen/attributen.",
    aiFailed: "Genereren mislukt. Probeer 't opnieuw.",
    valuePlaceholder: "Waarde",
    valueListPlaceholder: "Waarde1, waarde2, …",
    effect: "Effect",
    fill: "Vulkleur",
    dim: "Dimmen",
    cmp: {
      eq: "is gelijk aan",
      neq: "is niet",
      contains: "bevat",
      in: "is een van",
      gt: ">",
      gte: "≥",
      lt: "<",
      lte: "≤",
      exists: "is ingevuld",
      not_exists: "is leeg",
    },
  },
  simplify: {
    title: "Vereenvoudigen",
    toolbarTitle: "Vereenvoudig — genereer een vereenvoudigde kopie",
    close: "Sluiten",
    noDiagram: "Geen diagram geopend.",
    intro:
      "Genereert een vereenvoudigde kopie; het origineel blijft ongewijzigd. Kies één of meer transformaties.",
    hideLeaves: "Losse eindpunten verbergen",
    hideLeavesHint: "Verberg concepten zonder uitgaande relatie (vaak read-only dataobjecten).",
    cluster: "Rol samenstellingen op",
    clusterHint: "Verberg de onderdelen van een Composition/Aggregation; de 'geheel'-kant blijft.",
    criticalPath: "Alleen het pad tussen selectie",
    criticalPathHint: "Selecteer eerst precies 2 elementen op het canvas.",
    criticalPathReady: "Toont alleen het kortste pad tussen de 2 geselecteerde elementen.",
    collapseLayer: "Laag samenvouwen tot één blok",
    collapseLayerHint:
      "Alle elementen van de gekozen laag/lagen worden vervangen door één samengevouwen blok; hun relaties hechten aan dat blok.",
    promote: "Promoveer tot abstractie",
    promoteHint:
      "Vouw een service met z'n realiserende componenten/functies samen tot één ApplicationCollaboration-blok. Vink een voorgestelde cluster aan of gebruik je huidige selectie.",
    promoteSelection: "Huidige selectie ({{count}} elementen)",
    autoLayout: "Automatisch herschikken (netjes uitlijnen)",
    generate: "Genereer vereenvoudigde kopie",
    busy: "Bezig…",
    done: "Kopie gemaakt — {{count}} element(en) verborgen.",
    failed: "Vereenvoudigen mislukt. Probeer 't opnieuw.",
  },
  supernode: {
    defaultLabel: "Samengevouwen groep",
    badge: "{{count}} element(en)",
    badgeTooltip: "Aantal samengevouwen elementen in dit blok",
    layers: {
      strategy: "Strategie",
      business: "Bedrijf",
      application: "Applicatie",
      technology: "Technologie",
      physical: "Fysiek",
      motivation: "Motivatie",
      implementation_migration: "Implementatie & migratie",
      composite: "Composiet",
    },
  },
  groupEnclose: {
    title: "Hier een groep van maken?",
    description:
      '"{{group}}" omsluit nu deze objecten. Groeperen nest ze erin; kies per object welke relatie daarbij hoort. Niet groeperen laat het een vlak op de achtergrond.',
    allTo: "Alles op:",
    choose: "— kies —",
    noRelation: "geen relatie",
    nothingAllowed: "geen relatie toegestaan",
    cancel: "Niet groeperen",
    confirm: "Groeperen",
    fixedSharp: "aggregatie (Sharp-niveau)",
    fixedNone: "geen relatie nodig",
  },
  canvas: {
    undo: "Ongedaan maken",
    redo: "Opnieuw",
    deleteSelected: "Selectie van het diagram halen",
    penMenu: {
      title: "Object toevoegen",
      search: "Zoek een type…",
      none: "Geen typen gevonden",
      recent: "Laatst gebruikt",
    },
    penInput: {
      deleteChar: "Laatste teken wissen",
      clearField: "Veld leegmaken",
    },
    noDiagramOpen: "Geen diagram geopend — kies of maak een diagram",
    viewStateConflict: {
      notSaved_one:
        "'{{names}}' is nog niet opgeslagen — een collega heeft dit voorkomen intussen gewijzigd. Jouw versie staat er nog; verschuif 'm even opnieuw om 'm alsnog vast te leggen.",
      notSaved_other:
        "{{count}} voorkomens zijn nog niet opgeslagen ({{names}}) — een collega was je voor. Jouw versie staat er nog; verschuif ze even opnieuw om ze alsnog vast te leggen.",
      unnamed: "(zonder naam)",
      relation: "(relatie)",
      object: "een object",
    },
    edge: {
      ariaLabel: "Relatie van {{source}} naar {{target}}",
    },
    hiddenBadge: {
      tooltip_one: "{{count}} verborgen sub-element",
      tooltip_other: "{{count}} verborgen sub-elementen",
    },
    hiddenTotal: {
      label_one: "{{count}} verborgen op dit diagram",
      label_other: "{{count}} verborgen op dit diagram",
      tooltip:
        "Aantal elementen op dit diagram met `hidden`-flag. Klik een geneste container om er deelteller van te zien.",
    },
    collapseButton: {
      collapse: "Container inklappen — alle geneste elementen verbergen",
      expand: "Container uitklappen — verborgen elementen weer tonen",
    },
    contextMenu: {
      edit: "Bewerken",
      selectAll: "Alles selecteren",
      fitView: "Alles in beeld",
      zoomIn: "Inzoomen",
      zoomOut: "Uitzoomen",
      zoomReset: "Zoom terugzetten",
      delete: "Verwijderen",
      cleanUp: "Opruimen",
      merge: "Samenvoegen",
      mergeConceptsNotClones:
        "De geselecteerde objecten zijn niet identiek (zelfde type, naam en stereotypes) — samenvoegen niet mogelijk.",
      mergeRelationsNotClones:
        "De geselecteerde relaties zijn niet identiek (zelfde type, naam en richting) — samenvoegen niet mogelijk.",
      changeArchimateType: "Wijzig ArchiMate-type",
      showInExplorer: "Toon in Explorer",
    },
    nesting: {
      unnamed: "(zonder naam)",
      onDiagrams: "op: {{names}}",
      visibleEverywhere: "overal zichtbaar",
      notPlaced: "niet geplaatst",
      title: {
        pickRelationType: "Welk type relatie?",
        pickHiddenRelation: "Welke relatie wil je weer tonen?",
        mergeRelation: "Relatie samenvoegen?",
        mergeConcept: "Object samenvoegen?",
        pickExistingOrNew: "Bestaande relatie als template?",
      },
      description: {
        pickRelationType:
          "Je hebt een concept binnen een ander geplaatst. Kies welk type relatie hiermee samenhangt, of annuleer voor alleen visuele nesting.",
        pickHiddenRelation:
          "Tussen deze twee concepten zijn meerdere verborgen relaties op dit diagram. Kies welke je weer wilt tonen.",
        mergeRelation:
          "Deze relatie is identiek aan een bestaande (zelfde type, naam en richting). Kies een bestaande om mee samen te voegen — let op: de gewijzigde metadata van déze relatie vervalt dan t.g.v. de gekozen bestaande. Of houd beide.",
        mergeConcept:
          "Dit object is identiek aan een bestaand (zelfde type, naam en stereotypes). Kies een bestaand om mee samen te voegen — let op: de gewijzigde metadata van dít object vervalt dan t.g.v. het gekozen bestaande. Of houd beide.",
        pickExistingOrNew:
          "Tussen deze concepten bestaan al relaties. Kies een als template (zelfde type + eigenschappen → nieuwe relatie-instance op deze endpoints), of maak een verse relatie met de standaard relatietype.",
      },
      noOptions: "Geen geldige opties beschikbaar.",
      newRelation: "+ Nieuwe relatie (standaard type uit matrix)",
      keepBoth: "Beide houden (niet samenvoegen)",
      noRelation: "Geen relatie",
      removeOld_one: "Ook de relatie met «{{parent}}» ({{relations}}) uit het model verwijderen",
      removeOld_other:
        "Ook de {{count}} relaties met «{{parent}}» ({{relations}}) uit het model verwijderen",
      removeOldEverywhere:
        "Deze relaties staan op elk diagram waar beide objecten staan; verwijderen haalt ze ook daar weg.",
      removeOldElsewhere: "Ook te zien op: {{names}}. Verwijderen haalt ze ook daar weg.",
      removeOldOnlyHere: "Staat op geen ander diagram.",
      removeOldConfirm_one:
        "Ook de relatie met «{{parent}}» uit het model verwijderen? Die gaat naar de prullenbak en verdwijnt van elk diagram.",
      removeOldConfirm_other:
        "Ook de {{count}} relaties met «{{parent}}» uit het model verwijderen? Ze gaan naar de prullenbak en verdwijnen van elk diagram.",
    },
    relationMenu: {
      relationType: "Relatie-type",
      reverseDirection: "Omgekeerde richting",
      reversed: "{{label}} (omgekeerd)",
      directedOn: "✓ Gericht (halve pijl)",
      directed: "Gericht (halve pijl)",
      appearance: "Uiterlijk",
      routing: "Lijn-routing",
      clearWaypoints: "Knikpunten wissen",
    },
    pathRealization: {
      fallbackPath: "het pad",
      fallbackElement: "dit element",
      confirm:
        "Een pad wordt gerealiseerd door het element, niet andersom.\n\nZal ik een realisatie van '{{element}}' naar '{{path}}' maken?",
      failed: "De realisatie kon niet gemaakt worden.",
    },
    relationNotAllowedByViewKind:
      "Het diagramtype staat geen relaties toe tussen '{{source}}' en '{{target}}'.",
    noValidRelation:
      "Geen geldige relatie tussen '{{source}}' en '{{target}}' volgens de Relationship Matrix.",
    dropSkipped:
      "{{n}} concept(en) overgeslagen — type niet toegestaan op een diagram van type '{{viewKind}}'.",
    typeNotAllowed: "Type '{{type}}' is niet toegestaan op een diagram van type '{{viewKind}}'.",
    relationNeedsBothEnds:
      "Relatie kan niet getekend worden: '{{source}}' en '{{target}}' moeten beide op dit diagram staan.",
    bmc: {
      dropSkipped_one: "{{count}} concept(en) overgeslagen — passen niet in dit slot.",
      dropSkipped_other: "{{count}} concept(en) overgeslagen — passen niet in dit slot.",
      noTemplate: "Geen canvas-template geconfigureerd.",
      unassigned: "Niet-toegewezen — sleep naar een slot",
      dropRejected: "Slot '{{slot}}' accepteert alleen: {{allowed}}",
      moveUp: "Omhoog in stack",
      moveDown: "Omlaag in stack",
    },
    unnamed: "(zonder naam)",
    node: {
      nameTitle:
        "Dubbelklik om de naam in deze taal te wijzigen; sleep om te verschuiven; Cmd+dubbelklik reset positie",
    },
    sharp: {
      attribute: "Attribuut",
      identifierTitle:
        "Identifier — klik = select, rechtsklik = bewerken/verwijderen, sleep = volgorde",
      attributeTitle:
        "Attribuut — klik = select, rechtsklik = bewerken/verwijderen, sleep = volgorde",
    },
    listBox: {
      noTitle: "(geen titel)",
      empty: "Sleep objecten of diagrammen hierheen…",
      openDiagram: "Klik om diagram te openen",
      removeHint: "Rechtermuisklik = verwijderen",
    },
    edgeLabel: {
      widthPillTitle: "Sleep om breedte aan te passen · dubbelklik om te resetten",
      selectedTitle:
        "Sleep om te verplaatsen. Dubbelklik = naam wijzigen. Pak het ⇔ handvat rechts om de breedte aan te passen. Cmd/Alt+dubbelklik = terug naar standaard.",
      unselectedTitle:
        "Klik op de lijn om 'm te selecteren. Dubbelklik op het label = naam wijzigen.",
      widthHandleTitle: "Sleep om de label-breedte aan te passen. Dubbelklik om te resetten.",
      widthHandleAria: "Label-breedte aanpassen",
    },
  },
  uiGlossary: {
    button: "Begrippen op dit scherm",
    title: "Begrippen op dit scherm",
  },
  changeArchimateType: {
    title: "ArchiMate-type wijzigen",
    intro: "Kies het businesslaag-type voor «{{name}}». Het Concept-stereotype blijft behouden.",
    currentBadge: "huidig",
    noImpact: "Geen relaties raken ongeldig door deze wijziging.",
    impactWarning_one:
      "1 relatie kan niet behouden blijven onder het nieuwe type en wordt omgezet naar een gewone Associatie:",
    impactWarning_other:
      "{{count}} relaties kunnen niet behouden blijven onder het nieuwe type en worden omgezet naar gewone Associaties:",
    apply: "Type wijzigen",
    cancel: "Annuleren",
    applying: "Bezig…",
  },
  branchPicker: {
    modal: {
      title: "Nieuwe branch maken",
      name: "Naam",
      namePlaceholder: 'bv. "feature/api-redesign"',
      fromBranch: "Klonen vanaf branch",
      main: "main",
      fromSnapshot: "Of starten vanaf snapshot",
      snapshotNone: "— Geen (gebruik branch-HEAD)",
      noSnapshots: "Geen snapshots beschikbaar voor deze branch.",
      cancel: "Annuleren",
      create: "OK",
      creating: "Aanmaken…",
      errorEmptyName: "Voer een branch-naam in.",
    },
  },
  attributePanel: {
    cweLibrary: {
      openButton: "Kies uit CWE-bibliotheek",
      closeButton: "Sluiten",
      searchPlaceholder: "Zoek op CWE-naam...",
      noResults: "Geen resultaten.",
      notConfigured: "MITRE CWE-sync is niet geconfigureerd voor deze installatie.",
      cveHeading: "CVE's voor {{cweId}} (NVD):",
      skipButton: "Overslaan",
      noCveResults: "Geen CVE's gevonden bij NVD voor deze CWE.",
    },
    headerConcept: "Concept",
    headerRelation: "Relatie",
    headerDiagram: "Diagram",
    headerEmpty: "Geen selectie",
    emptyHint: "Selecteer een blokje of een verbinding op het canvas.",
    sectionType: "Type",
    subtypeLabel: "Subtype",
    subtypeNone: "{{type}} (geen subtype)",
    sectionLabel: "Label",
    sectionAttributes: "Attributen",
    multiplicityDiscouraged:
      "Multipliciteit is op dit relatietype zelden zinnig — ArchiMate 4 staat het toe, maar de betekenis is hier onbepaald. Overweeg of je bedoeling niet beter in een «Concept Constraint» past.",
    sectionStereotypes: "Stereotypes",
    sectionLineRouting: "Lijn-routing",
    sectionColours: "Kleuren",
    sectionEndpoints: "Endpoints",
    sectionOwner: "Eigenaar",
    nameNl: "Naam (NL)",
    nameEn: "Naam (EN)",
    nameDerivedHint:
      "Afgeleid van het gekoppelde attribuuttype — wijzig via het Attribuuttype-veld.",
    descriptionDerivedHint:
      "Afgeleid van de definitie van het gekoppelde attribuuttype — wijzig 'm in de Glossary.",
    descriptionNl: "Beschrijving (NL)",
    descriptionEn: "Beschrijving (EN)",
    labelNl: "Label (NL)",
    labelEn: "Label (EN)",
    altLabels: {
      title: "Alternatieve labels (voor niet-ArchiMate-diagrammen)",
      hint: "Optioneel — toont een eigen naam in C4/Sharp/BMC-diagrammen. Leeg laten = gebruikt de gewone naam.",
      diagramsWord: "diagrammen",
    },
    colourFill: "Vulling",
    colourStroke: "Lijn",
    colourText: "Tekst",
    colourLabelBg: "Label-bg",
    routing: {
      smoothstep: "Smoothstep (rechte hoeken, afgerond)",
      step: "Step (rechte hoeken)",
      straight: "Recht",
      bezier: "Bezier (vloeiend)",
      manual: "Handmatig (knikpunten)",
    },
    endpointFrom: "van",
    endpointTo: "naar",
    readonlyOwnerHint:
      "Read-only: alleen de eigenaar of een workspace-admin kan name/type/parent wijzigen.",
    versionLabel: "Versie {{n}}",
    historyTitle: "Versie-historie tonen",
    historyAria: "Versie-historie",
    closeAria: "Inklappen",
    instance: {
      loseLocalValuesConfirm:
        "Let op: de lokale waarden van deze instance gaan verloren. Vanaf nu gelden de waarden van de relatie. Doorgaan?",
      storeOnInstanceLabel: "Gegevens opslaan bij de instantie op het diagram",
      storeOnRelation: "Nee — op de relatie",
      storeOnThisInstance: "Ja — op deze instance",
      revertTitle: "Zet de waarden + vlag terug naar het moment dat je dit paneel opende",
      revertButton: "Herstel mutaties",
    },
    unknownViewKind: "{{viewKind}} (onbekend)",
    configuration: "Configuratie",
    yes: "Ja",
    no: "Nee",
    chooseOption: "— kies —",
    optgroupTypes: "Types",
    colourSlotTitle: "{{label}} — klik om aan te passen",
    transparent: "Transparant",
    colourDefault: "Standaard",
    relationTypeCurrent: "{{label}} (huidig)",
    reverseDirection: "Omgekeerde richting",
    relationTypeReversed: "{{label}} (omgekeerd)",
    forwardCount: "{{n}} forward",
    reversedCountSuffix: ", {{n}} omgekeerd",
    link: {
      title: "Link",
      none: "Geen",
      url: "URL",
    },
    sectionNotation: "Notatie",
    notationRectangle: "Rechthoek",
    notationArchimate: "ArchiMate-symbool",
    bilingual: {
      translateFailed: "Vertaling mislukt: {{error}}",
      translating: "vertalen…",
    },
    fields: {
      ownerOnly: "owner only",
      commaSeparated: "comma-separated",
      commaSeparatedPerLanguage: "comma-separated per taal",
      unsupportedType: "unsupported type: {{type}}",
      deletedRef: "(verwijderd) {{id}}…",
      none: "geen",
      removeRef: "Verwijder {{label}}",
      addRef: "+ toevoegen…",
      addFacet: "+ facet toevoegen…",
      newFacet: "＋ Nieuw {{type}} “{{name}}”",
      sameNameSuffix: " (zelfde naam)",
      addButton: "Toevoegen",
      enumTbd: "— nog kiezen (verplicht) —",
    },
  },
  explorer: {
    collapseAll: "Alle groepen inklappen",
    detail: {
      sectionProperties: "Eigenschappen",
      sectionRelations: "Relaties",
      sectionDiagramOccurrences: "Diagram-voorkomens",
      sectionAttributes: "Attributen",
      sectionObjectReferences: "Objectreferenties",
      rowName: "Naam",
      rowDescription: "Beschrijving",
      rowBranch: "Branch",
      rowViewKind: "View kind",
      rowUpdatedAt: "Laatst gewijzigd",
      empty: "leeg",
      noRelations: "Geen relaties.",
      noDiagrams: "Komt op geen enkel diagram voor (orphan).",
      noObjects: "Empty diagram — geen objectreferenties.",
      loading: "Detail laden…",
      openButton: "Open",
      openTitle: "Diagram openen op canvas",
      editHint: "Klik om te bewerken in het Eigenschappen-paneel",
      deleteObjectTitle: "Object verwijderen (incl. alle relaties en diagram-voorkomens)",
      deleteButton: "Verwijder",
      doubleClickHint: "Dubbelklik om in het Eigenschappen-paneel te openen",
      relationRowHint:
        "Klik = selecteren + canvas focussen — dubbelklik = ook attributen-paneel openen — slepen = op actief diagram plaatsen",
      collapseOccurrences: "Diagram-voorkomens inklappen",
      expandOccurrences: "Diagram-voorkomens uitklappen",
      showOccurrencesTitle: "Toon diagrammen waar deze relatie op staat",
      notPlaced: "Niet op een diagram geplaatst",
      instance: "Instance {{n}}",
      instanceTitle: "Instance {{n}} — {{diagram}}",
      attrChildHint: "Klik = select; dubbelklik = bewerken; sleep = naar diagram",
      kindIdentifier: "Identifier",
      kindAttribute: "Attribuut",
      deleteDiagramConfirm: "Diagram '{{name}}' verwijderen?",
      deleteDiagramFailed: "Diagram verwijderen mislukt — zie console.",
      unknownViewKind: "{{viewKind}} (onbekend)",
      deleteDiagramTitle: "Diagram verwijderen",
      changeTypeTitle: "Diagram-type wijzigen",
      selectObjectTitle: "Selecteer object {{name}} in de tree",
    },
    pinned: "Vastgepind",
    pinPanel: "Pin paneel",
    workpackageLabel: "Workpackage",
    branchLabel: "Branch",
    choose: "— kies —",
    closedSuffix: " (closed)",
    newBranchOption: "+ Nieuwe branch…",
    search: {
      placeholder: "Zoek in objecten + diagrammen…",
      ariaLabel: "Zoek in explorer",
      clear: "Wissen",
      clearAria: "Zoekveld wissen",
      noResults: 'Geen resultaten voor "{{query}}".',
    },
    selection: {
      selectedCount: "{{n}} geselecteerd",
      moveToFolder: "Verplaats naar folder…",
      deleteTitle:
        "Verwijder geselecteerd(e) object(en) en diagram(men) — sneltoets: Delete / Backspace",
      summary: "{{n}} items geselecteerd (multi-select)",
    },
    bulkDelete: {
      confirmDiagrams_one: "{{count}} diagram verwijderen?",
      confirmDiagrams_other: "{{count}} diagrammen verwijderen?",
    },
    deleteFailed: "Verwijderen mislukt — zie console.",
    empty: {
      noWorkpackages:
        "Geen workpackages zichtbaar — vraag de admin om READ/WRITE-rechten of maak een nieuw workpackage aan.",
      pickWpBranch: "Kies een workpackage + branch om de tree te zien.",
      branchEmpty: "Deze branch is leeg.",
    },
    item: {
      orphanTitle: "Orphan — komt op geen enkel diagram voor",
      tombstoneTitle: "Verwijderd op deze branch",
      conceptHint: "Klik = select; sleep = naar diagram; rechter-klik = open in diagram",
      hideDetail: "Verberg detail-paneel",
      showDetail: "Toon detail-paneel",
      collapseDetail: "Detail inklappen",
      expandDetail: "Detail uitklappen",
      fromFolder: "Uit folder {{folder}} (Base)",
      referenceFromBase: "Reference object uit Base",
      openInDiagram: "Open in diagram…",
      emptyDiagramTitle: "Empty diagram — geen objectreferenties",
      diagramHint: "Klik = select; dubbel-klik = open",
    },
    diagramsGroup: "[Diagrams]",
    branchOwnTitle: "Branch-eigen op '{{branch}}'",
    openInDiagram: {
      title: "Open in diagram — {{name}}",
      none: "Dit object komt op geen enkel diagram voor.",
    },
    contextMenu: {
      label: "Acties",
      open: "Openen",
      openInDiagram: "Openen in diagram…",
      properties: "Eigenschappen",
      rename: "Hernoemen",
      deleteDiagram: "Diagram verwijderen…",
      deleteFromModel: "Opruimen…",
    },
  },
  foldertree: {
    multiSelect: {
      selectedIn_one: "{{count}} geselecteerd in {{folder}}",
      selectedIn_other: "{{count}} geselecteerd in {{folder}}",
      moveOutTitle: "Verplaats uit folder…",
      deleteTitle: "Verwijderen",
      clearTitle: "Selectie wissen",
      deleteConfirm:
        "{{count}} concept(en) verwijderen? Dit wist ook hun relaties en occurrences op diagrammen. Niet ongedaan te maken (snapshot maken kan via Repository-menu).",
      deletePartial: "{{ok}}/{{total}} verwijderd; {{failed}} mislukt.",
    },
    wpSelectTitle: "Workpackage kiezen",
    baseSuffix: " (Base)",
    title: "Foldertree (Base)",
    newFolder: "+ Nieuwe folder",
    baseRoot: "Base",
    loadingFolders: "Folders laden…",
    noFolders: 'Nog geen folders aangemaakt. Klik op "+ Nieuwe folder" bovenin.',
    footer: "Relaties + Kladblok-canvas voor cross-folder modelleren: volgende iteratie.",
    form: {
      name: "Naam",
      namePlaceholder: "Bijv. Klanten",
      description: "Beschrijving (optioneel)",
      descriptionPlaceholder: "Korte toelichting wat deze folder bevat",
      typeClass: "Type-klasse (vast na creatie)",
      submit: "Folder aanmaken",
    },
    editModal: {
      title: "Folder bewerken",
    },
    errorBar: {
      closeAria: "Foutmelding sluiten",
      close: "sluit",
    },
    filter: {
      searchPlaceholder: "Zoek folder…",
      label: "Filter:",
      all: "Alle",
    },
    folder: {
      collapseAria: "Folder inklappen",
      expandAria: "Folder uitklappen",
      typeClassTitle: "Type-klasse: {{group}}",
      objCount: ", {{n}} obj",
      editTitle: "Naam + beschrijving bewerken",
      exportTitle: "Folder exporteren naar JSON (uitgaand)",
      exportAria: "Exporteren",
      importTitle: "JSON importeren in folder (inkomend)",
      importAria: "Importeren",
      snapshotTitle: "Snapshot van deze folder maken (folder-scoped)",
      snapshotAria: "Folder snapshot",
      empty: "Leeg — sleep een type uit het palette hierheen.",
      expandTypeGroupAria: "Type-groep uitklappen",
      collapseTypeGroupAria: "Type-groep inklappen",
      deleteConfirm:
        "Folder '{{name}}' verwijderen?\n\nConcepten erin verliezen hun «Reference Object»-stereotype en blijven in de Base-workpackage achter.",
      snapshotSuccess:
        "✓ Snapshot van folder '{{name}}' gemaakt: {{concepts}} concept(en), {{relations}} relatie(s). Terug te vinden in Instellingen → Snapshots → scope 'Base'.",
    },
    concept: {
      collapseAria: "Concept inklappen",
      expandAria: "Concept uitklappen",
      noRelations: "Geen relaties",
      collapse: "Inklappen",
      expand: "Uitklappen",
      rowTitle: "{{typeId}}\n(klik = selecteren, dubbelklik = attributenpaneel openen)",
      rename: "Hernoemen",
      deleteConfirm: "Concept '{{label}}' verwijderen?",
    },
    relation: {
      rowTitle: "{{typeId}}\n{{typeLabel}}\n(dubbelklik = attributenpaneel openen)",
      deleteTitle: "Relatie verwijderen",
      deleteConfirm: "Relatie '{{typeId}}' verwijderen?",
    },
    import: {
      confirm:
        "Importeren van '{{file}}' in folder '{{folder}}'? Bestaande objecten met dezelfde UUID worden bijgewerkt; nieuwe objecten worden toegevoegd met behoud van originele UUID.",
      skippedNote: ", {{n}} relatie(s) geskipt",
      updatedNote: ", {{n}} bijgewerkt",
      reassignedNote:
        "\n{{n}} object(en) kregen een nieuw id, omdat ze al in een andere workspace bestaan.",
      success:
        "✓ {{inserted}} concept(en) toegevoegd{{updatedNote}} + {{relations}} relatie(s) geïmporteerd{{skippedNote}}.{{reassignedNote}}",
    },
    errors: {
      loadFolders: "Folders laden mislukt: {{msg}}",
      createFolder: "Folder aanmaken mislukt: {{msg}}",
      updateFolder: "Folder bijwerken mislukt: {{msg}}",
      renameFolder: "Folder hernoemen mislukt: {{msg}}",
      deleteRelation: "Relatie verwijderen mislukt: {{msg}}",
      renameConcept: "Concept hernoemen mislukt: {{msg}}",
      deleteConcept: "Concept verwijderen mislukt: {{msg}}",
      selectionClassMismatch:
        "Selectie heeft type-class '{{cls}}' en past niet in folder '{{folder}}' ({{group}}).",
      moveToFolder: "Verplaatsen naar '{{folder}}' mislukt: {{msg}}",
      moveSkipped: "Verplaatsen overgeslagen: {{reason}}",
      unknownReason: "onbekende reden",
      paletteClassMismatch:
        "'{{typeId}}' valt onder folder-class '{{folderClass}}' maar folder '{{folder}}' accepteert alleen '{{group}}'.",
      createConcept: "Concept aanmaken in '{{folder}}' mislukt: {{msg}}",
      export: "Folder-export mislukt: {{msg}}",
      import: "Folder-import mislukt: {{msg}}",
      deleteFolder: "Folder verwijderen mislukt: {{msg}}",
      snapshot: "Folder-snapshot maken mislukt: {{msg}}",
    },
  },
  heatMap: {
    empty: "Geen concepten gevonden",
    noEnumOptions:
      "De gekozen attributen hebben geen enum-opties. Kies twee enum-attributen op het rechter paneel.",
    notConfigured: {
      title: "Heat-map nog niet geconfigureerd",
      body: "Kies in het rechter-paneel een (sub)type en twee enum-attributen.",
    },
    noAxisValue: "Geen waarde op as",
    v2: {
      notConfiguredTitle: "Heatmap nog niet geconfigureerd",
      notConfiguredBody:
        "Selecteer dit diagram in de Explorer (links) en kies in het AttributePanel een doel-(sub)type plus twee assen.",
      noAxisValues:
        "Geen waarden gevonden op één van beide assen. Bij numerieke attributen: zorg dat er concepten met een waarde zijn.",
    },
    editNameTitle: "Dubbelklik om de naam te bewerken",
    toolbar: {
      move: "Verplaats toolbar (volgende hoek)",
      zoomOut: "Uitzoomen (scroll-wiel omlaag)",
      resetZoom: "Reset naar 100%",
      zoomIn: "Inzoomen (scroll-wiel omhoog)",
    },
    dragReorderValues: "Sleep om de volgorde van waarden aan te passen",
    relation: {
      notConfiguredTitle: "Relatie-heatmap nog niet geconfigureerd",
      notConfiguredBody:
        "Open dit diagram in de Diagrammen-paneel of dubbelklik op de achtergrond. Kies vervolgens een relation-stereotype, een relation-attribuut, een template-stereotype en een template-attribuut in het AttributePanel.",
      notEnumTitle: "Attributen niet enum/numeriek",
      notEnumBody:
        "Heatmap-assen vereisen een enum- of numeriek attribuut. Kies in het AttributePanel andere attributen.",
      plotted: "relaties geplot",
      hidden: "verborgen — geen template of waarde",
      diagonal: "diagonaal-referentie",
    },
  },
  profiles: {
    hideDetails: "Details verbergen",
    intro:
      "Een specialisatieprofiel verbijzondert een standaardtype — getoond met «guillemets». Profielen uit een pack worden door dat pack onderhouden en zijn hier alleen te bekijken; zelf gedefinieerde profielen gelden binnen dit workpackage en zijn hier te bewerken.",
    searchPlaceholder: "Zoek op naam of label…",
    "new": "+ Nieuw profiel",
    formNew: "Nieuw profiel",
    formEdit: "Profiel bewerken",
    fieldName: "Naam",
    fieldNameHint:
      "De identiteit van het profiel — hiermee wordt 'ie overal aangeduid. Kies een prefix, bijvoorbeeld eigen.Kernapplicatie.",
    fieldRenameHint:
      "Hernoemen mag. Elk object dat dit profiel draagt wordt meteen meeverhuisd; alleen kleur-overlay-regels die de naam noemen moet je zelf nalopen.",
    confirmRename:
      'Profiel "{{from}}" hernoemen naar "{{to}}"? Alle objecten die het dragen worden bijgewerkt.',
    renameDone:
      'Hernoemd naar "{{to}}". Bijgewerkt: {{concepts}} concept(en), {{relations}} relatie(s), {{diagrams}} diagram(men).',
    renameViewStateWarning_one:
      "Let op: 1 diagram noemt de oude naam nog in een kleur-overlay-regel — die is niet automatisch bijgewerkt.",
    renameViewStateWarning_other:
      "Let op: {{count}} diagrammen noemen de oude naam nog in een kleur-overlay-regel — die zijn niet automatisch bijgewerkt.",
    fieldLabelNl: "Label (NL)",
    fieldLabelEn: "Label (EN)",
    fieldAppliesTo: "Toepasbaar op",
    fieldAppliesToHint: "Meerdere mogelijk. Zonder basistype is het profiel nergens toe te kennen.",
    fieldIcon: "Icoon",
    colorClear: "Kleur wissen",
    fieldColors: "Kleuren",
    detailDescription: "Beschrijving",
    detailAttrKey: "Sleutel",
    detailColorHint: "zoals het op het canvas rendert",
    detailAttrLabel: "Label",
    detailRequired: "verplicht",
    detailAttributes: "Attributen ({{count}})",
    detailAttrOptions: "Keuzes",
    inspect: "Details tonen",
    detailAnyType: "elk type",
    detailAttrType: "Type",
    detailNoAttributes: "Dit profiel voegt geen velden toe.",
    colorText: "Tekst",
    colorStroke: "Rand",
    colorFill: "Vulling",
    fieldColorsHint:
      "Leeg laten betekent: volg de laagkleur van het basistype, zoals nu. Een profiel dat wél een kleur heeft wint van die laagkleur, maar niet van een kleur die het DOM zelf voorschrijft.",
    colorPreview: "Voorbeeld",
    fieldIconHint:
      "Kiezen uit de meegeleverde set. Deze iconen kleuren mee met de rand van het object.",
    iconNone: "— geen eigen icoon —",
    sectionOwn: "Eigen profielen ({{count}})",
    sectionPacks: "Uit een pack ({{count}})",
    packsHint: "Deze worden door hun pack onderhouden en zijn hier niet te wijzigen.",
    noneOwn: "Nog geen eigen profielen in dit workpackage.",
    edit: "Bewerken",
    delete: "Verwijderen",
    cancel: "Annuleren",
    save: "Opslaan",
    saving: "Opslaan…",
    loading: "Laden…",
    confirmDelete: 'Profiel "{{name}}" verwijderen?',
    loadFailed: "Profielen laden mislukt.",
    saveFailed: "Opslaan mislukt.",
    deleteFailed: "Verwijderen mislukt.",
  },
  ameffReview: {
    title: "AMEFF-import — bevestig classificatie",
    summaryLabels_one: "{{count}} label",
    summaryLabels_other: "{{count}} labels",
    summaryDiagrams_one: "{{count}} diagram",
    summaryDiagrams_other: "{{count}} diagrammen",
    summaryAnd: " en ",
    summarySuffix:
      " herkend. Pas hieronder de typering aan; alleen gewijzigde rijen worden bijgewerkt.",
    bulk: "Bulk:",
    bulkAllDrawing: "Alles → Tekening",
    bulkAllRisk: "Alles → Risico",
    bulkReset: "Reset naar heuristic-suggestie",
    colSource: "Bron",
    colKind: "Soort",
    colName: "Naam",
    colTypeStereotype: "Type / stereotype",
    colDiagramType: "Diagramtype",
    chipAuto: "auto",
    chipAutoTitleLabel: "Voorstel via kleur+keyword",
    chipAutoTitleView: "Voorstel via view-naam-match",
    chipNone: "—",
    chipNoneTitle: "Geen match",
    chipElement: "element",
    chipElementTitle: "Geïmporteerde Label-node → wordt een concept-object",
    chipView: "view",
    chipViewTitle: "AMEFF-view → wordt een diagram",
    sectionLabels: "Labels",
    sectionDiagrams: "Diagrammen",
    sectionAmbiguous: "Meervoudige conversies",
    summaryAmbiguous_one: "{{count}} meervoudige conversie",
    summaryAmbiguous_other: "{{count}} meervoudige conversies",
    ambiguousHint:
      "ArchiMate 4 laat voor deze 3.x-typen meer dan één doeltype toe. Het gekozen type staat hieronder; het specialisatieprofiel blijft ongewijzigd en bewaart de oorspronkelijke identiteit.",
    colLegacyType: "3.x-type",
    colTargetType: "Wordt",
    chipDefault: "default",
    chipDefaultTitle: "Automatisch gekozen doeltype — wijzigbaar",
    defaultSuffix: " (default)",
    unknownSuffix: " (onbekend)",
    close: "Sluiten zonder wijzigen",
    apply: "Toepassen",
    applying: "Bezig…",
    errorFallback: "Patch mislukt",
    choiceDrawing: "— Geen (Tekening)",
    choiceRisk: "Risico",
    choiceVulnerability: "Kwetsbaarheid",
    choiceThreatEvent: "Bedreigingsgebeurtenis",
    choiceThreatActor: "Bedreigingsactor",
    choiceLossEvent: "Schadegebeurtenis",
    choiceControlObjective: "Beheersdoelstelling",
    choiceSecurityPrinciple: "Beveiligingsprincipe",
    choiceCountermeasure: "Beheersmaatregel",
    choiceAsset: "Asset",
  },
  setup: {
    title: "Nieuwe installatie inrichten",
    intro:
      "Deze installatie heeft nog geen beheerder en geen mailinstelling. Richt die hier één keer in; daarna gaat deze pagina dicht.",
    closed: "Deze installatie is al ingericht.",
    toLogin: "Naar inloggen",
    next: "Verder",
    back: "Terug",
    saved: "Opgeslagen.",
    saveAndNext: "Opslaan en verder",
    claim: {
      code: "Setupcode (uit het installatiescript of het log)",
      phrase: "Setupzin",
      computing: "Bezig met rekenen…",
      expires: "Geldig tot {{date}}.",
    },
    refused: {
      already_used:
        "De setupcode werkt niet meer: er is al iets ingericht. Was jij dat niet, vernietig de installatie en begin opnieuw.",
      expired: "De setupcode is verlopen. Maak een nieuwe met ae-install reset-setup-code.",
      locked: "Te veel foute pogingen. Maak een nieuwe code met ae-install reset-setup-code.",
      not_configured:
        "De installatie mist SETTINGS_ENCRYPTION_KEY (of bij een setupzin SETUP_PHRASE_SALT).",
    },
    mail: {
      title: "1. Mail",
      intro:
        "Met deze instelling gaan de inlogcodes de deur uit. Gebruik de SMTP-server van je organisatie of een dienst zoals Amazon SES, Azure Communication Services of Resend.",
      host: "SMTP-server",
      port: "Poort",
      username: "Gebruikersnaam",
      password: "Wachtwoord",
      fromAddress: "Afzender (e-mailadres)",
      fromName: "Afzender (naam, optioneel)",
      testTo: "Testmail naar…",
      test: "Stuur testmail",
      testSent: "Testmail verstuurd naar {{to}}.",
      testHint: "De testmail werkt pas na opslaan.",
    },
    admin: {
      title: "2. Beheerder en eerste workspace",
      intro:
        "De super-admin beheert de installatie en is admin van de eerste workspace. Dat adres krijgt zo meteen een inlogcode.",
      email: "E-mailadres super-admin",
      workspaceName: "Naam eerste workspace",
      language: "Standaardtaal",
    },
    ai: {
      title: "3. Claude (optioneel)",
      intro:
        'Vul een Anthropic API-sleutel in voor vertalen en "Vraag Claude", of sla dit over. Workload Identity Federation stel je later in onder Instellingen → Workspace → AI.',
      skip: "Overslaan",
    },
    confirm: {
      title: "4. Bevestigen",
      intro:
        "Er is een inlogcode gestuurd naar {{email}}. Vul die in om de inrichting af te ronden.",
      resend: "Stuur opnieuw",
      resent: "Nieuwe code verstuurd.",
      finish: "Afronden en inloggen",
    },
  },
  settings: {
    title: "Instellingen",
    backToEditor: "← Terug naar editor",
    common: {
      cancel: "Annuleren",
      save: "Opslaan",
      saving: "Opslaan…",
      delete: "Verwijderen",
      edit: "Bewerken",
      create: "Aanmaken",
      creating: "Aanmaken…",
      refresh: "↻ Vernieuw",
      noWorkspace: "Geen workspace geladen.",
      unknownError: "Onbekende fout",
      close: "Sluiten",
      loading: "Laden…",
    },
    tabs: {
      account: "Account",
      diagramTypes: "Diagramtypes",
      subtypes: "Subtypes",
      profiles: "Specialisatieprofielen",
      validation: "Validatie",
      portability: "Export / Import",
      email: "E-mail",
      quotas: "Quotas",
      workpackages: "Workpackages",
      teams: "Teams",
      branches: "Branches",
      snapshots: "Snapshots",
      trash: "Prullenbak",
      audit: "Audit-log",
      maintenance: "Onderhoud",
      superAdmin: "Workspace",
      apiTokens: "API-tokens",
      ai: "AI",
      globalMail: "E-mail (globaal)",
    },
    account: {
      aiNote:
        'De aanmelding bij de AI-aanbieder (voor vertalen en "Vraag Claude") regelt een super-admin voor de hele installatie, onder Instellingen → Workspace → AI.',
      aiModelSectionTitle: 'AI-model voor "Vraag Claude"',
      aiModelDescription:
        "Welk Claude-model er gebruikt wordt wanneer je een diagram door Claude laat herontwerpen. Sterkere modellen geven betere kwaliteit maar zijn langzamer en duurder.",
      modelLabel: "Model",
      modelDefault: "Standaard",
      modelRecommended: "aanbevolen",
      modelSaved: "AI-model voorkeur opgeslagen: {{label}}",
      modelReset: "AI-model voorkeur teruggezet naar standaard.",
      effortLabel: "Nadenken",
      effortDefault: "Standaard (Gebalanceerd)",
      effortLow: "Snel: denkt kort na, voor eenvoudige vragen",
      effortMedium: "Gebalanceerd",
      effortHigh: "Grondig: denkt het langst na, voor lastige herontwerpen",
      effortDescription:
        "Hoe lang Claude nadenkt voor het antwoordt in Vraag Claude. Korter is sneller en goedkoper; in de dialoog kun je het per vraag nog wijzigen.",
      effortSaved: "Voorkeur voor nadenken opgeslagen.",
    },
    aiAuth: {
      provider: "Aanbieder: {{name}}.",
      providerFuture:
        "Andere aanbieders (zoals OpenAI) zijn nog niet gebouwd; bijdragen zijn welkom.",
      title: "Aanmelden bij Anthropic",
      intro:
        'Vertalen, "Vraag Claude" en de kleur-overlay gebruiken Claude. Kies hoe deze installatie zich bij de AI-aanbieder aanmeldt; dat geldt voor alle workspaces. Workload Identity Federation heeft de voorkeur: dan is er geen langlevende sleutel. Staan beide ingesteld, dan valt de editor bij een storing terug op de sleutel.',
      wifTitle: "Workload Identity Federation",
      wifIntro:
        "Neem deze drie waarden over in de Claude Console (Settings › Workload identity): registreer de editor als issuer en maak een federation-regel met precies dit subject. Vul daarna de ID's hieronder in.",
      wifUnavailable:
        "Deze installatie kan nog geen tokens tekenen: de beheerder moet WIF_SIGNING_KEY en PUBLIC_ORIGIN instellen. Tot die tijd werkt alleen een API-sleutel.",
      issuer: "Issuer-URL",
      jwksUrl: "JWKS-URL",
      subject: "Subject",
      copy: "Kopieer",
      copied: "Gekopieerd",
      organizationId: "Organization-ID",
      serviceAccountId: "Service-account-ID (svac_…)",
      federationRuleId: "Federation-regel-ID (fdrl_…)",
      anthropicWorkspaceId: "Anthropic-workspace-ID (wrkspc_…, optioneel)",
      anthropicWorkspaceHint: "Alleen nodig als de regel meerdere Anthropic-workspaces dekt.",
      saveWif: "WIF opslaan",
      clearWif: "WIF uitzetten",
      wifSet: "Ingesteld",
      keyTitle: "API-sleutel",
      keyIntro:
        "Een sleutel uit de Claude Console. Hij wordt versleuteld opgeslagen; daarna zie je alleen de laatste vier tekens.",
      keySet: "Ingesteld, eindigt op {{last4}}",
      keyUnset: "Geen sleutel",
      newKey: "Nieuwe sleutel",
      keyPlaceholder: "sk-ant-…",
      keyWorkspace: "Anthropic-workspace-ID (wrkspc_…, optioneel)",
      keyWorkspaceHelp:
        'Alleen nodig bij een sleutel die niet aan één Anthropic-workspace hangt: Anthropic antwoordt dan "This API key is not scoped to a workspace". Vul het ID in (begint met wrkspc_), niet de naam; je vindt het in de Claude Console onder Settings › Workspaces, bij de workspace zelf.',
      saveKey: "Sleutel opslaan",
      clearKey: "Sleutel wissen",
      test: "Test",
      testing: "Bezig…",
      testOk: "Werkt ({{mode}}).",
      testFailed: "Mislukt: {{detail}}",
      modeWif: "Workload Identity Federation",
      modeKey: "API-sleutel",
      modeDevKey: "lokale sleutel uit .dev.vars",
      lastFailure: "Laatste fout ({{date}}): {{reason}}",
      saved: "Opgeslagen.",
      notConfigured:
        "Er is geen aanmelding bij een AI-aanbieder ingesteld. Een super-admin stelt die in onder Instellingen → Workspace → AI.",
    },
    diagramTypes: {
      title: "Diagramtypes",
      description:
        "Workspace-eigen diagramtypes die je naast de standaard Open Group viewpoints kunt gebruiken. Ieder workspace-lid kan een type aanmaken; de maker (of een workspace-admin) kan het bewerken of verwijderen.",
      newButton: "+ Nieuw type",
      emptyHintBefore: "Nog geen custom diagramtypes. Klik op ",
      emptyHintCta: "+ Nieuw type",
      emptyHintAfter: " om er een te maken.",
      centrallyManagedBadge: "centraal beheerd",
      conceptTypesCount_one: "{{count}} concept-type",
      conceptTypesCount_other: "{{count}} concept-typen",
      relationTypesCount_one: "{{count}} relatie-type",
      relationTypesCount_other: "{{count}} relatie-typen",
      creatorLabel: " · maker ",
      editTitleEnabled: "",
      editTitleManaged: "Centraal beheerd — alleen admins",
      editTitleOther: "Alleen de maker of een admin kan dit type wijzigen",
      deleteConfirm:
        "Diagramtype '{{name}}' verwijderen? Diagrammen die het gebruiken worden teruggezet naar 'Anything'.",
      editorTitleCreate: "Nieuw diagramtype",
      editorTitleEdit: "Bewerk diagramtype",
      nameNl: "Naam (NL)",
      nameEn: "Naam (EN)",
      descriptionNl: "Beschrijving (NL)",
      descriptionEn: "Beschrijving (EN)",
      allowedConceptTypes: "Toegestane concept-types ({{count}})",
      allowedRelationTypes: "Toegestane relatie-types ",
      relationSubset: "(subset van {{count}})",
      relationAllAllowed: "(alle matrix-toegestane)",
      restrictRelationTypes: "Beperk relatie-types",
      centrallyManagedLabel: "Centraal beheerd",
      centrallyManagedHint:
        " — wanneer aangevinkt kunnen alleen workspace-admins dit type bewerken of verwijderen.",
      validationNameRequired: "Vul minstens één naam in (NL of EN).",
      validationTypesRequired: "Kies minstens één concept-type.",
      translating: "vertalen…",
    },
    validation: {
      summary: "{{fields}} velden bij {{objects}} objecten wachten nog op een waarde.",
      description:
        "Alle required-velden die nog een TBD/NTB-placeholder dragen in de actieve branch. Vul ze in om het model compleet te maken.",
      empty: "Geen openstaande TBD/NTB-velden — alles is ingevuld.",
      jumpHint: "Klik om dit object te openen in het eigenschappen-paneel",
      col: {
        object: "Object",
        type: "Type / stereotype",
        field: "Veld",
        value: "Waarde",
        lastEdit: "Laatst gewijzigd",
      },
    },
    subtypes: {
      title: "Subtypes",
      descriptionBefore:
        'Workspace-eigen specializaties — bijvoorbeeld "PaymentService" als subtype van ',
      descriptionAfter:
        ". Het subtype erft het volledige attribuut-schema van zijn parent. Elk workspace-lid kan een subtype aanmaken; de maker of een workspace-admin kan het bewerken of verwijderen.",
      newButton: "+ Nieuw subtype",
      emptyHintBefore: "Nog geen subtypes. Klik op ",
      emptyHintCta: "+ Nieuw subtype",
      emptyHintAfter: " om er een te maken.",
      extendsLabel: "extends {{parent}}",
      byCreator: "Door {{email}}",
      extraAttributesCount_one: " · {{count}} extra attribuut",
      extraAttributesCount_other: " · {{count}} extra attributen",
      deleteConfirm:
        'Subtype "{{name}}" verwijderen?\n\nBestaande concepten van dit subtype worden teruggezet naar het parent-type "{{parent}}". Hun data blijft bewaard, maar de subtype-specifieke attributen verdwijnen.',
      deleteFailed: "Verwijderen mislukt",
      createFailed: "Aanmaken mislukt",
      formTitle: "Nieuw subtype",
      parentTypeLabel: "Parent-type",
      nameNl: "Naam (NL)",
      nameEn: "Naam (EN)",
      nameNlPlaceholder: "Betalingsservice",
      nameEnPlaceholder: "Payment service",
      descriptionNl: "Beschrijving (NL)",
      descriptionEn: "Beschrijving (EN)",
      inheritsNote:
        "Het subtype krijgt automatisch alle attributen van het parent-type. De hieronder toegevoegde attributen komen daar bovenop.",
      validationParentRequired: "Kies een parent-type.",
      validationNamesRequired: "Vul zowel een Nederlandse als Engelse naam in.",
      formTitleEdit: "Subtype bewerken",
      saveFailed: "Opslaan mislukt.",
      parentImmutable: "Het parent-type kan na aanmaken niet meer wijzigen.",
      attrsLabel: "Eigen extra-attributen",
      attrsHint:
        "Bovenop de attributen van het parent-type. De sleutel is machine-leesbaar (bv. sla_level); het label is wat de modelleur ziet.",
      attrName: "sleutel",
      attrLabelNl: "Label (NL)",
      attrLabelEn: "Label (EN)",
      attrType: {
        string: "Tekst (kort)",
        bilingual_string: "Tekst NL/EN",
        int: "Getal",
        bool: "Ja/nee",
        date: "Datum",
        enum: "Keuzelijst",
      },
      attrRequired: "Verplicht",
      attrOptions: "opties, komma-gescheiden",
      attrRemove: "Verwijder",
      attrAdd: "+ Attribuut toevoegen",
      validationAttr: "Elk attribuut heeft een sleutel en minstens één label nodig.",
      validationAttrOptions: 'Keuzelijst "{{name}}" heeft minstens één optie nodig.',
    },
    portability: {
      introTitle: "Export / Import",
      introBefore:
        " verplaatst een volledig model (concepten, relaties, diagrammen) tussen workspaces of installaties: als JSON, of als AMEFF (Open Group ArchiMate Model Exchange File Format, .xml) voor uitwisseling met andere ArchiMate-tools.",
      introDetail1:
        "Een JSON-import houdt het id van een object aan als dat vrij is. Bestaat het id al op de doel-branch, dan wordt dat object bijgewerkt; is het elders in gebruik (in deze of een andere workspace), dan krijgt het object ",
      introDetailNewIds: "een nieuw id",
      introDetailAnd:
        '. Een nieuw object waarvan de naam al bestaat krijgt "[imported]" achter de naam, en jij wordt ',
      introDetailOwner: "eigenaar",
      introDetailAfter:
        " van alles wat je importeert. Een AMEFF-import maakt altijd nieuwe objecten met nieuwe id's.",
      exportTitle: "Exporteren",
      exportDescription:
        "Download live concepten, relaties en diagrammen als JSON-bestand. 'Hele workspace': alle concepten en relaties van de workspace plus de diagrammen van de branch waarop je staat. 'Eén workpackage': de inhoud van dat workpackage (je huidige branch als je erin werkt, anders de hoofdbranch). Verwijderde items en versiegeschiedenis gaan niet mee.",
      exportButton: "Download JSON",
      exportSuccess: "'{{filename}}' gedownload ({{size}}).",
      importTitle: "Importeren",
      importDescription:
        "Upload een eerder geëxporteerd JSON-bestand. De inhoud komt in de huidige branch: objecten waarvan het id daar al bestaat worden bijgewerkt, de rest komt erbij.",
      importButton: "Kies JSON-bestand…",
      importConfirm:
        "'{{filename}}' ({{size}}) importeren in de huidige branch? Objecten waarvan het id daar al bestaat worden bijgewerkt; de rest komt naast de bestaande data.",
      importInvalidJson: "Bestand is geen geldige JSON.",
      importedSuccess: "Geïmporteerd: {{parts}}.{{safetyNote}}",
      importConceptsPart: "{{total}} concepten ({{inserted}} nieuw, {{updated}} bijgewerkt)",
      importRelationsPart: "{{total}} relaties ({{inserted}} nieuw, {{updated}} bijgewerkt)",
      importDiagramsPart: "{{total}} diagrammen ({{inserted}} nieuw, {{updated}} bijgewerkt)",
      importCustomViewKindsPart: "{{total}} eigen diagram-types",
      importSkippedRelations: "{{count}} relaties geskipt (dangling endpoint)",
      importSafetyNote:
        " Vóór de import is automatisch een snapshot '{{label}}' gemaakt — terug te zetten via Snapshots-tab als nodig.",
      reviewTitle_one: '⚠ {{count}} object gemarkeerd met "[imported]"',
      reviewTitle_other: '⚠ {{count}} objecten gemarkeerd met "[imported]"',
      reviewDescription:
        "Deze objecten zijn nieuw aangemaakt en hun naam kwam al voor — `[imported]` achter de naam gezet. Mogelijk zijn het duplicaten. Klik op een naam om 'm te bewerken, of haal het achtervoegsel weg in het Eigenschappen-paneel. Is het hetzelfde object? Haal het achtervoegsel weg en voeg de twee samen: rechtsklik → Samenvoegen op het diagram, of Repository → Ontdubbel alle objecten.",
      reviewLabelConcepts: "Concepten",
      reviewLabelRelations: "Relaties",
      reviewLabelDiagrams: "Diagrammen",
      reviewLabelCustomViewKinds: "Eigen diagram-types",
      countConcepts_one: "{{count}} concept",
      countConcepts_other: "{{count}} concepten",
      countRelations_one: "{{count}} relatie",
      countRelations_other: "{{count}} relaties",
      countDiagrams_one: "{{count}} diagram",
      countDiagrams_other: "{{count}} diagrammen",
      countCustomViewKinds_one: "{{count}} eigen diagramtype",
      countCustomViewKinds_other: "{{count}} eigen diagramtypes",
      countDrawings_one: "{{count}} visuele primitief (decoratie op diagrammen)",
      countDrawings_other: "{{count}} visuele primitiefs (decoratie op diagrammen)",
      exportSuccessWithCounts: "'{{filename}}' gedownload ({{size}}){{counts}}.",
      errorNoTargetBranch: "Geen doel-workpackage geselecteerd of WP heeft geen main-branch.",
      currentWp: "huidige WP",
      ameffImportConfirm:
        "Importeren van AMEFF-bestand '{{filename}}' ({{size}}) in workpackage {{target}}? AMEFF-import maakt altijd verse UUIDs; pre-import-snapshot wordt NIET automatisch gemaakt (maak er zelf één via Snapshots-tab als 'n veiligheidsnet gewenst is).",
      importCancelled: "Import afgeblazen — er is niets gewijzigd.",
      ameffConcepts: "{{n}} concepten",
      ameffRelations: "{{n}} relaties",
      ameffDiagrams: "{{n}} diagrammen",
      ameffConceptsSkipped: "{{n}} concept(en) geskipt",
      ameffRelationsSkipped: "{{n}} relatie(s) geskipt",
      ameffDiagramsSkipped: "{{n}} diagram(men) geskipt",
      ameffRelationsToCheck: "{{n}} relatie(s) om te controleren",
      unknownElementTypes: "onbekende elementtypes: {{types}}",
      unknownRelationshipTypes: "onbekende relatietypes: {{types}}",
      zeroItems: "0 items",
      ameffImportSuccess: "AMEFF-import in {{target}}: {{parts}}{{tail}}.",
      importConfirmTarget:
        "'{{filename}}' ({{size}}) importeren in workpackage {{target}}? Objecten waarvan het id daar al bestaat worden bijgewerkt; de rest komt naast de bestaande data.",
      importConceptsPartReused:
        "{{total}} concepten ({{inserted}} nieuw, {{updated}} bijgewerkt, {{reused}} hergebruikt (folder-match))",
      foldersCreated: "{{n}} folder(s) automatisch aangemaakt in Base",
      importedSuccessTarget: "Geïmporteerd in {{target}}: {{parts}}.{{safetyNote}}",
      scopeLegend: "Scope",
      scopeWorkspace: "Hele workspace",
      scopeWorkpackage: "Eén workpackage",
      wpScopeHint:
        "Folder-objecten die deze workpackage subscribed worden inline meegenomen met hun folder-naam. Bij import in een andere workspace worden ze gematcht via folder + naam + type — bestaande Reference-Objects worden hergebruikt (UUID-link).",
      ameffExportTitle:
        "Open Group ArchiMate Model Exchange File Format — uitwisseling met Archi, BiZZdesign, enz. Volgt de scope-keuze: 'Hele workspace' exporteert de branch waarop je staat, 'Eén workpackage' de hoofdbranch van het gekozen workpackage.",
      ameffExportButton: "Download AMEFF (XML)",
      importDescriptionTarget:
        "Upload een eerder geëxporteerd JSON-bestand en kies in welk workpackage het terechtkomt. Objecten waarvan het id daar al bestaat worden bijgewerkt; de rest komt erbij.",
      targetWpLabel: "Doel-workpackage:",
      folderMatchHint:
        "Folder-objecten in het bestand (met «Reference Object»-stereotype + folder-naam) worden gematcht op naam + type in de Base-WP. Bestaande matches → hergebruikt; nieuwe → in de folder gezet; folder ontbreekt in target → stereotype gestript, import als gewoon concept in deze WP.",
      ameffImportTitle:
        "Open Group ArchiMate Model Exchange File Format — uitwisseling met Archi, BiZZdesign, etc.",
      ameffImportButton: "Kies .archimate-bestand (AMEFF)…",
      suffixHeading_one: '{{count}} object gemarkeerd met "[imported]"',
      suffixHeading_other: '{{count}} objecten gemarkeerd met "[imported]"',
      suffixBody:
        "Deze objecten zijn nieuw aangemaakt en hun naam kwam al voor in het doel-workpackage — `[imported]` achter de naam gezet. Mogelijk zijn het duplicaten. Klik op een naam om 'm te bewerken, of haal het achtervoegsel weg in het Eigenschappen-paneel. Is het hetzelfde object? Haal het achtervoegsel weg en voeg de twee samen: rechtsklik → Samenvoegen op het diagram, of Repository → Ontdubbel alle objecten.",
      uuidHeading_one: "{{count}} object kreeg een verse UUID",
      uuidHeading_other: "{{count}} objecten kregen een verse UUID",
      uuidBody:
        "Deze objecten hadden in het importbestand een UUID die elders al in gebruik is (in deze of een andere workspace). Er is een verse UUID toegekend om PRIMARY-KEY-conflicten te vermijden — de naam is onveranderd, geen actie vereist. Relaties + parent-pointers wijzen automatisch naar de nieuwe UUIDs.",
    },
    mail: {
      introTitle: "Twee transport-opties:",
      mcLabel: "MailChannels",
      mcDescriptionBefore: " — gratis HTTP-relay, geen credentials nodig. Vereist ",
      mcWel: "wel",
      mcDescriptionAfter: " een DNS TXT-record op het from-domein (",
      mcDescriptionEnd:
        ") zodat MailChannels weet dat deze worker namens jouw domain mag versturen.",
      smtpLabel: "SMTP",
      smtpDescriptionBefore:
        " — directe verbinding met je eigen SMTP-server via Cloudflare Workers' TCP-socket-API. Vul ",
      smtpHost: "host",
      smtpComma: ", ",
      smtpPort: "poort",
      smtpUsername: "username",
      smtpEn: " en ",
      smtpPassword: "wachtwoord",
      smtpDescriptionAfter:
        " in. Poort 465 = implicit TLS; alle andere poorten (typisch 587) gebruiken STARTTLS.",
      fieldTransport: "Transport",
      fieldFromAddress: "From-adres",
      fieldFromName: "From-naam",
      fieldSmtpHost: "SMTP host",
      fieldPort: "Poort",
      fieldSmtpUsername: "SMTP username",
      fieldSmtpPassword: "SMTP wachtwoord",
      passwordSet: " (al opgeslagen)",
      passwordPlaceholderSet: "•••••••• (laat leeg om te behouden)",
      transportMailchannels: "MailChannels (HTTP-relay)",
      transportSmtp: "SMTP (eigen server, directe verbinding)",
      fromAddressPlaceholder: "noreply@jouwbedrijf.nl",
      fromNamePlaceholder: "Arch-designer",
      hostPlaceholder: "smtp.gmail.com",
      usernamePlaceholder: "(optioneel)",
      savedToast: "Opgeslagen.",
      removedToast: "Mail-config verwijderd.",
      removeConfirm: "Mail-config wissen voor deze workspace?",
      testButton: "Verstuur test-mail",
      testButtonTitleConfigured: "Test-mail naar je eigen e-mail",
      testButtonTitleNotConfigured: "Eerst opslaan",
      testSuccess: "Test-mail verstuurd naar {{recipient}}.",
      clearConfig: "Wis config",
      saveButton: "Opslaan",
      updatedBy: "Laatst gewijzigd door {{user}} op {{date}}.",
    },
    quotas: {
      sectionTitle: "Daglimiet voor Vraag Claude",
      defaultLimitBefore: "Standaard-limiet:",
      defaultLimitDetail: "{{count}} 'Vraag Claude'-aanvragen per dag",
      defaultLimitAfter: ". Reset om 00:00 UTC. Override hieronder per gebruiker.",
      userEmailLabel: "Gebruiker (e-mail)",
      userEmailPlaceholder: "user@bedrijf.nl",
      dailyLimitLabel: "Daglimiet",
      addOverrideButton: "+ Override",
      emptyHint: "Nog geen overrides — alle gebruikers gebruiken de standaard-limiet.",
      colUser: "Gebruiker",
      colKind: "Soort",
      colLimit: "Limiet",
      colChanged: "Gewijzigd",
      errorInvalidEmail: "Geen geldig e-mailadres.",
      errorInvalidLimit: "Limiet moet een niet-negatief geheel getal zijn.",
      toastReset: "{{email}}: terug naar default.",
      toastSaved: "{{email}}: {{limit}}/dag opgeslagen.",
      saveButton: "Opslaan",
      removeOverrideTitle: "Verwijder override (terug naar default)",
    },
    workpackages: {
      subtabWorkpackages: "Workpackages",
      subtabBranches: "Branches",
      subtabFolderPermissions: "Folder-autorisaties",
      subtabTeamPermissions: "Team-autorisaties",
      subtabCopy: "Kopiëren",
      newTitle: "Nieuw workpackage",
      newDescription:
        "Een workpackage groepeert branches, concepten en diagrammen onder één noemer — een project, een business-line, een specifiek thema. Per workpackage kunnen teams afzonderlijk geautoriseerd worden (zie Team-autorisaties).",
      nameLabel: "Naam",
      namePlaceholder: "bv. EDM, Customer Project Q3",
      descriptionLabel: "Beschrijving (optioneel)",
      descriptionPlaceholder: "Wat is de scope van dit workpackage?",
      createButton: "Aanmaken",
      createdToast: "Workpackage '{{name}}' aangemaakt.",
      listTitle: "Workpackages",
      listDescription:
        "Klik op een rij om naam of beschrijving aan te passen. Sluiten houdt het workpackage beschikbaar maar markeert het als afgesloten; verwijderen ruimt alles op (irreversibel).",
      empty: "Nog geen workpackages aangemaakt.",
      baseBadge: "base",
      baseBadgeTitle:
        "Speciale workpackage met gedeelde reference-objecten — admin-only en niet bewerkbaar.",
      closedBadge: "gesloten",
      createdByOn: "aangemaakt door {{user}} op {{date}}",
      editPlaceholderName: "Naam",
      editPlaceholderDescription: "Beschrijving",
      saveButton: "Opslaan",
      editButton: "Bewerken",
      editTitleBase: "Base-workpackage is immutable",
      editTitleEnabled: "Naam + beschrijving bewerken",
      closeButton: "Sluiten",
      reopenButton: "Heropenen",
      toggleTitleBase: "Base-workpackage kan niet worden gesloten",
      toggleTitleReopen: "Open dit workpackage opnieuw",
      toggleTitleClose: "Sluit dit workpackage",
      updatedToast: "Workpackage bijgewerkt.",
      deletedToast: "Workpackage '{{name}}' verwijderd.",
      statusToastOpen: "Workpackage '{{name}}' is nu open.",
      statusToastClosed: "Workpackage '{{name}}' is nu gesloten.",
      deleteButton: "Verwijderen",
      deleteTitleBase: "Base-workpackage kan niet worden verwijderd",
      deleteTitleEnabled: "Verwijder workpackage (cascadeert naar branches/concepten/diagrammen)",
      deleteConfirm:
        "Weet je zeker dat je workpackage '{{name}}' wilt verwijderen?\n\nDit verwijdert ALLE branches, concepten, relaties en diagrammen die in dit workpackage leven. Cross-workpackage-copy-bronvermeldingen die hiernaar wijzen worden ook gewist.\n\nDeze actie kan niet ongedaan worden gemaakt.",
      deleteToast: "Workpackage '{{name}}' verwijderd.",
      folderSectionTitle: "Folder-subscriptions per workpackage",
      folderSectionDescriptionBefore: "Geef een workpackage ",
      folderSectionRead: "read",
      folderSectionAnd: "- of ",
      folderSectionWrite: "write",
      folderSectionDescriptionMid:
        "-toegang tot een folder uit de Base-workpackage. Per folder kan maximaal één workpackage ",
      folderSectionDescriptionEnd:
        "-recht hebben; andere WPs lezen mee. Workpackages zonder subscription zien de folder niet.",
      folderEmptyNoWps:
        "Maak eerst een (non-Base) workpackage aan om subscripties te kunnen beheren.",
      folderEmptyNoFolders: "Nog geen folders aangemaakt in de Base-workpackage.",
      workpackageSelect: "Workpackage",
      folderColFolder: "Folder",
      folderColSubscription: "Subscription",
      folderColWriteHolder: "Write-houder",
      folderThisWp: "(deze WP)",
      folderRevoked: "Subscriptie ingetrokken.",
      folderSet: "Folder-access op '{{mode}}' gezet.",
      folderWriteHeldBy: "Write-recht heeft '{{name}}'",
      teamSectionTitle: "Team-permissies per workpackage",
      teamSectionDescriptionBefore: "Geef een team ",
      teamSectionDescriptionMid: "- of ",
      teamSectionDescriptionEnd:
        "-toegang tot een workpackage. Het Admin-team is uitgesloten — admins hebben sowieso volledige toegang via hun rol.",
      teamEmptyNoWps: "Geen open workpackages om te beheren.",
      teamEmptyNoTeams:
        "Geen teams aangemaakt (anders dan Admin). Maak eerst een team in de Teams-tab.",
      teamColTeam: "Team",
      teamColAccess: "Toegang",
      teamRevoked: "Toegang ingetrokken.",
      teamSet: "Team-permissie op '{{mode}}' gezet.",
      copyTitle: "Kopiëren tussen workpackages",
      copyNeedTwo:
        "Maak minstens twee open (non-Base) workpackages aan om concepten te kunnen kopiëren.",
      copyDescription:
        "Kopieert geselecteerde concepten en diagrammen uit de main-branch van de bron-WP naar de main-branch van de doel-WP. Relaties tussen geselecteerde concepten worden automatisch meegekopieerd. Folder-objecten worden overgeslagen — die beheer je via folder-subscripties. ViewState-verwijzingen in diagrammen die niet in de selectie zitten worden gestript (geen dangling refs).",
      copySourceLabel: "Bron-workpackage",
      copyTargetLabel: "Doel-workpackage",
      copyModeLabel: "Match-mode",
      copyModeMatch: "Hergebruik bij naam+type-match",
      copyModeMatchDesc:
        " — concepten met dezelfde type-id én naam (NL of EN) in de doel-WP worden hergebruikt; rest wordt nieuw aangemaakt.",
      copyModeAlwaysNew: "Altijd nieuw",
      copyModeAlwaysNewDesc:
        " — elk concept krijgt een fresh UUID in de doel-WP, ook als er een naam-match is. (Folder-objecten blijven geskipt.)",
      copySourceContent: "Bron-WP inhoud",
      copyClearSelection: "Selectie wissen",
      copyObjects: "Objecten",
      copyDiagrams: "Diagrammen",
      copySelectionHint:
        "{{objects}} object(en) · {{diagrams}} diagram(men) geselecteerd. Diagram-selectie expandeert automatisch naar alle objecten en relaties op dat diagram. Object-selectie kopieert relaties tussen geselecteerde objecten mee.",
      copyDryRun: "Dry-run (preview)",
      copyRun: "Kopiëren",
      copyResult: "Resultaat",
      copyResultDryRun: " (dry-run)",
      copyColPass: "Pass",
      copyColReused: "Hergebruikt",
      copyColCreated: "Nieuw",
      copyColSkipped: "Overgeslagen",
      copyRowConcepts: "Concepten",
      copyRowRelations: "Relaties",
      copyRowDiagrams: "Diagrammen",
      copyDetails: "Details per item",
      copyDetailUnnamed: "(naamloos {{kind}})",
      copyErrorSame: "Source en target moeten verschillend zijn.",
      copyErrorEmpty: "Selecteer minstens één concept of diagram.",
      copyDoneDryRun: "Dry-run — {{summary}} (created+reused).",
      copyDoneRun: "Klaar — {{summary}} (created+reused).",
      explorerEmpty: "Geen {{title}} in bron-WP.",
      explorerLoading: "Bron-WP laden…",
      explorerTombstoned: "verwijderd",
      layerDrawing: "Tekenen",
      copySummary:
        "concepten {{cc}}+{{cr}}={{ct}} · relaties {{rc}}+{{rr}}={{rt}} · diagrammen {{dc}}+{{dr}}={{dt}}",
    },
    teams: {
      newTeamTitle: "Nieuw team",
      newTeamDescription:
        "Een team groepeert gebruikers voor workpackage-autorisaties. Is het eerste lid nog geen lid van de workspace, dan wordt die er automatisch aan toegevoegd. Het eerste lid krijgt een e-mail over het team.",
      nameLabel: "Naam",
      namePlaceholder: "bv. Architecten, Solution-design",
      founderLabel: "Eerste lid (e-mail)",
      founderPlaceholder: "naam@bedrijf.nl",
      descriptionLabel: "Beschrijving (optioneel)",
      createButton: "Team aanmaken",
      createdToast: "Team '{{name}}' aangemaakt.",
      listTitle: "Teams",
      listDescriptionBefore: "Klik op een rij om leden te beheren. Leden van het ",
      listDescriptionAdminTeam: "Admin-team",
      listDescriptionAfter:
        " krijgen automatisch admin-rechten op de workspace; dat team is auto-aangemaakt en kan niet worden hernoemd of verwijderd.",
      empty: "Nog geen teams aangemaakt.",
      adminBadge: "admin",
      adminBadgeTitle:
        "Leden krijgen automatisch admin-rechten op deze workspace. Auto-aangemaakt en immutable.",
      toggleMembersHide: "Verberg leden",
      toggleMembersShow: "Leden",
      toggleMembersTitleHide: "Verberg leden",
      toggleMembersTitleShow: "Toon en beheer leden",
      deleteButton: "Verwijderen",
      deleteTitleAdmin: "Het Admin-team kan niet worden verwijderd",
      deleteTitleOther: "Verwijder team + leden + permissies",
      deleteConfirm: "Team '{{name}}' verwijderen? Leden + permissies gaan mee.",
      deletedToast: "Team '{{name}}' verwijderd.",
      noMembers: "Geen leden.",
      memberRemove: "verwijder",
      memberEmailPlaceholder: "email@bedrijf.nl",
      addMember: "+ Lid",
      addedAdmin: "'{{email}}' toegevoegd — krijgt admin-rechten.",
      addedRegular: "'{{email}}' toegevoegd aan team '{{name}}'.",
      removeConfirm: "'{{email}}' verwijderen uit team '{{name}}'?",
      removedAdmin: "'{{email}}' verwijderd — admin-rechten ingetrokken.",
      removedRegular: "'{{email}}' verwijderd uit team.",
    },
    branches: {
      wpPickerTitle: "Workpackage",
      wpPickerEmpty: "Geen open workpackages beschikbaar.",
      wpPickerBaseMarker: "Base",
      introBefore: "",
      introBoldTitle: "Branches",
      introAfter:
        " zijn parallelle versies van de diagrammen binnen deze workspace. Concepten en relaties zijn gedeeld; diagrammen zijn per branch.",
      introStatuses1: "Een branch heeft één van drie statussen: ",
      statusActive: "active",
      statusActiveLong: " (bewerkbaar), ",
      statusMerged: "merged",
      statusMergedLong: " (afgerond, history), ",
      statusAbandoned: "abandoned",
      statusAbandonedLong:
        " (gestopt). De hoofdbranch van een workpackage is altijd actief en kan niet worden hernoemd of verwijderd.",
      newSectionTitle: "Nieuwe branch maken",
      nameLabel: "Naam",
      namePlaceholder: 'bv. "feature/api-redesign"',
      sourceLabel: "Bron",
      sourceFromBranch: "Vanaf bestaande branch:",
      sourceFromSnapshot: "Vanaf snapshot:",
      createButton: "Maak branch",
      createdToast: "Branch '{{name}}' aangemaakt.",
      empty: "Nog geen branches.",
      currentBadge: "huidig",
      colName: "Naam",
      colStatus: "Status",
      colSource: "Bron",
      colCreated: "Aangemaakt",
      colCreatedBy: "Door",
      colActions: "Acties",
      sourceSnapshotMarker: "(snapshot)",
      renamePrompt: "Hernoem branch '{{name}}' naar:",
      renamedToast: "Branch hernoemd naar '{{name}}'.",
      renameButton: "Naam",
      renameTitleMain: "Hoofdbranche mag niet hernoemd",
      renameTitleEnabled: "Hernoem",
      mergedButton: "Merged",
      mergeButton: "⇥ Samenvoegen in {{parent}}",
      mergeButtonTitle: "De inhoud van deze branch opnemen in de ouder",
      deleteMergeHint:
        "\n\nWil je de plateaus eronder behouden? Gebruik dan 'Samenvoegen': de inhoud gaat op in de ouder en de branches eronder krijgen die als ouder.",
      abandonButton: "⊘ Abandon",
      reactivateButton: "Reactiveer",
      deleteButton: "Verwijderen",
      deleteButtonTitle: "Verwijder branch + diagrammen",
      statusConfirmAbandoned:
        "Status van '{{name}}' wijzigen naar '{{status}}'? Deze branch wordt onbewerkbaar.",
      statusConfirmMerged:
        "Status van '{{name}}' wijzigen naar '{{status}}'? Markeer als gemerged — onbewerkbaar maar blijft als history.",
      statusConfirmActive:
        "Status van '{{name}}' wijzigen naar '{{status}}'? Reactiveer voor verdere bewerking.",
      statusToast: "Status van '{{name}}' is nu '{{status}}'.",
      deleteConfirm:
        "Branch '{{name}}' definitief verwijderen? Alles wat op deze branch is gemaakt of gewijzigd (objecten, relaties, diagrammen) en z'n snapshots gaat weg; wat de branch van hoger erfde blijft daar staan. Dit kan NIET ongedaan worden gemaakt.",
      deleteConfirmSubtree:
        "Branch '{{name}}' definitief verwijderen, samen met de branches eronder?\n\n{{list}}\n\nVan al deze branches gaat alles wat erop is gemaakt of gewijzigd weg, met hun snapshots en hun plateau op de roadmap. Dit kan NIET ongedaan worden gemaakt.",
      deletedToast: "Branch '{{name}}' verwijderd.",
      badgeActive: "active",
      badgeMerged: "merged",
      badgeAbandoned: "abandoned",
    },
    snapshots: {
      introBefore: "",
      introBoldTitle: "Snapshots",
      introAfter:
        " bewaren de volledige workspace-state (concepten, relaties, diagrammen) als één moment in de tijd. Handig vóór grote refactorings of als checkpoint van een milestone.",
      introDetail:
        "Een restore zet alle live data terug; objecten die later zijn toegevoegd worden tombstoned (zichtbaar in Prullenbak). Vóór elke restore wordt automatisch een veiligheids-snapshot gemaakt — terugdraaien is altijd mogelijk.",
      newSectionTitle: "Nieuwe snapshot maken",
      labelLabel: "Label",
      labelPlaceholder: 'bv. "Voor {{date}} refactor"',
      messageLabel: "Bericht (optioneel)",
      messagePlaceholder: "Vrije tekst — context voor toekomstige restore-beslissingen.",
      createButton: "Maak snapshot",
      createdToast:
        "Snapshot '{{label}}' gemaakt — {{concepts}} concepten, {{relations}} relaties, {{diagrams}} diagrammen, {{viewStates}} viewState-entries.",
      reusedToast: "Er is niets veranderd sinds snapshot '{{label}}' — geen nieuwe gemaakt.",
      statusLater: "Nu niet terug te zetten.",
      statusNever: "Kan niet meer terug.",
      structureIntro: "Deze snapshot zet ook de plateaus eronder terug naar hoe ze toen waren:",
      branchRemoved: "• '{{name}}' verdwijnt (bestond toen nog niet)",
      branchRecreated: "• '{{name}}' komt terug",
      showAllBranches: "Toon snapshots van alle branches",
      scopeLabel: "Scope:",
      scopeWorkspace: "Workspace (workspace-wide snapshots)",
      scopeBaseMarker: "Base",
      empty: "Nog geen snapshots — maak er hierboven één.",
      colLabel: "Label",
      colWhen: "Wanneer",
      colWho: "Door",
      colContent: "Inhoud",
      colSize: "Grootte",
      colActions: "Acties",
      restoreButton: "Terugzetten",
      restoreTitle: "Werkruimte terugzetten naar deze snapshot",
      restoreConfirm:
        "Snapshot '{{label}}' terugzetten? Alle concepten/relaties/diagrammen die niet in de snapshot staan, worden tombstoned (te herstellen via Prullenbak). Er wordt automatisch eerst een veiligheids-snapshot gemaakt.",
      restoreConfirmBranch:
        "Snapshot '{{label}}' terugzetten? Het plateau en de plateaus eronder gaan terug naar hoe ze toen waren; wat er sindsdien op is gemaakt verdwijnt. Alleen deze plateaus gaan even op slot. Er wordt automatisch eerst een veiligheids-snapshot gemaakt.",
      restoreCancelled: "Terugzetten afgeblazen — er is niets gewijzigd.",
      restoredToast:
        "'{{label}}' hersteld. Concepts: +{{ci}} ~{{cu}} -{{ct}}. Relations: +{{ri}} ~{{ru}} -{{rt}}. Diagrams: ~{{dr}} -{{dx}}. Veiligheids-snapshot: '{{safety}}'.",
      jsonButton: "JSON",
      jsonTitle: "Open de JSON-content in een nieuw tabblad",
      deleteButton: "Verwijderen",
      deleteTitle: "Definitief verwijderen",
      deleteConfirm:
        "Snapshot '{{label}}' definitief verwijderen? De R2-blob en metadata worden weggegooid. Dit kan niet ongedaan worden gemaakt.",
      deletedToast: "Snapshot '{{label}}' verwijderd.",
      reloadHint: "De pagina laadt automatisch opnieuw zodra je dit venster sluit.",
    },
    trash: {
      selectGroup: "Alles van {{when}} selecteren",
      cleanupTitle: "Definitief opruimen",
      refresh: "Vernieuwen",
      introBefore: "",
      introBoldTitle: "Prullenbak",
      introAfter:
        " bevat verwijderde concepten en relaties. Tot ze definitief worden verwijderd kun je ze herstellen.",
      introDetail:
        "De automatische cron-job ruimt verwijderde concepten niet op — die blijven hier staan tot een admin ze definitief verwijdert. Orphan-relaties (bron/doel hard verwijderd) gaan wél automatisch.",
      restoreButton: "Herstel ({{count}})",
      purgeSelectionButton: "Definitief verwijderen ({{count}})",
      olderThanLabel: "Items ouder dan",
      purgeOlderButton: "Verwijder definitief",
      purgeAllButton: "Prullenbak legen",
      purgeAllTitle: "Alle items in deze prullenbak definitief verwijderen",
      empty: "De prullenbak is leeg.",
      itemsCount_one: "{{count}} item",
      itemsCount_other: "{{count}} items",
      kindConcept: "Concept",
      kindRelation: "Relatie",
      noName: "(geen naam)",
      noLabel: "(zonder label)",
      placedOn: "Stond op",
      expandGroup: "Toon items in deze delete-actie",
      collapseGroup: "Verberg items in deze delete-actie",
      danglingBadge: "Bron of doel ook weg",
      danglingTitle:
        "Bron of doel van deze relatie staat ook in de prullenbak — herstellen vereist beide.",
      restoreEmpty: "Niets hersteld.",
      restoreSuccess: "Hersteld: {{parts}}.",
      restoreConcepts_one: "{{count}} concept",
      restoreConcepts_other: "{{count}} concepten",
      restoreRelations_one: "{{count}} relatie",
      restoreRelations_other: "{{count}} relaties",
      restoreSkipped:
        "{{base}} {{count}} relatie(s) geskipt — bron of doel was niet ge-selecteerd voor herstel.",
      purgeConfirm:
        "Definitief verwijderen van {{count}} item(s)? Dit kan niet ongedaan worden gemaakt.",
      purgedToast: "Verwijderd: {{concepts}} concept(en), {{relations}} relatie(s).",
      purgeOlderConfirm: "Verwijder definitief alle prullenbak-items met een datum vóór {{date}}?",
      purgedOlderToast:
        "Verwijderd: {{concepts}} concept(en), {{relations}} relatie(s) ouder dan {{date}}.",
      purgeAllConfirm:
        "Prullenbak helemaal leegmaken? Alle {{count}} items worden definitief verwijderd. Dit kan NIET ongedaan worden gemaakt.",
      purgedAllToast:
        "Prullenbak geleegd: {{concepts}} concept(en), {{relations}} relatie(s) verwijderd.",
    },
    audit: {
      introBefore: "",
      introBoldTitle: "Audit-log",
      introAfter:
        " registreert wie wat wanneer heeft hersteld of definitief verwijderd via de prullenbak en snapshots. Gebruik deze trail om te reconstrueren waarom een object er (niet meer) is.",
      introDetailBefore: "Read-only — voer acties uit via de tabbladen ",
      introDetailSnapshots: "Snapshots",
      introDetailAnd: " en ",
      introDetailTrash: "Prullenbak",
      introDetailAfter: ".",
      filterLabel: "Filter",
      filterAll: "Alle acties",
      actionTrashRestore: "Prullenbak: hersteld",
      actionTrashPurge: "Prullenbak: definitief verwijderd",
      actionTrashPurgeShort: "Prullenbak: verwijderd",
      actionSnapshotCreate: "Snapshot: aangemaakt",
      actionSnapshotRestore: "Snapshot: hersteld",
      actionSnapshotDelete: "Snapshot: verwijderd",
      emptyNoFilter: "Geen audit-entries gevonden voor deze filter.",
      detailTrashRestore: "{{concepts}} concept(en), {{relations}} relatie(s) hersteld.",
      detailTrashRestoreSkipped: "{{count}} relatie(s) overgeslagen (dangling endpoint).",
      detailTrashPurgeBefore: "Modus: ",
      detailTrashPurgeOlderThan: " ouder dan {{date}}",
      detailTrashPurgeAfter:
        " — {{concepts}} concept(en), {{relations}} relatie(s) definitief verwijderd.",
      detailSnapshotRestoreFrom: "Hersteld vanuit ",
      detailSnapshotRestoreSafety: " — veiligheids-snapshot: ",
      detailSnapshotDeleteSuffix: " verwijderd",
    },
    maintenance: {
      introBefore: "",
      introBoldTitle: "Garbage collection",
      introAfter:
        " verwijdert objecten die naar niet-bestaande concepten verwijzen — orphan-relaties (bron of doel hard verwijderd) en viewState-entries die zijn achtergebleven na een delete.",
      introDetailBefore: "Draait automatisch ",
      introDetailBold: "volgens een schema",
      introDetailAfter:
        " via Cloudflare Cron — standaard elke dag om 03:00 UTC; een super-admin stelt de tijd in onder Instellingen → Workspace → Cron jobs. De knop hieronder draait 'm meteen voor deze workspace.",
      runNowButton: "Run nu",
      runningButton: "Bezig…",
      lastRuns: "Laatste runs",
      empty: "Nog geen runs uitgevoerd voor deze workspace.",
      colWhen: "Wanneer",
      colTrigger: "Trigger",
      colStatus: "Status",
      colRelations: "Relaties",
      colViewState: "ViewState",
      colDiagrams: "Diagrammen",
      colWho: "Door",
      triggerCron: "Cron",
      triggerManual: "Handmatig",
      statusSuccess: "Klaar",
      statusError: "Fout",
      runDoneNothing: "Klaar in {{ms}}ms — niks om op te ruimen.",
      runDoneCleaned:
        "Klaar in {{ms}}ms — {{relations}} relaties verwijderd, {{viewstates}} viewState-entries opgeschoond.",
      retired: {
        heading: "Retired objecten opruimen",
        intro:
          "Auto-sync-bronnen (bv. MITRE CWE) markeren objecten die uit hun bron-catalogus verdwenen zijn met «Retired» i.p.v. ze meteen te verwijderen. Deze actie ruimt ze definitief op.",
        scopeLabel: "Scope:",
        scopeWorkspace: "Workspace (alle workpackages incl. Base)",
        scopeWorkpackage: "Workpackage:",
        scopeWorkpackageHint: "(Base is hier geen optie — gebruik Workspace-scope voor Base.)",
        previewButton: "Toon retired objecten →",
        previewingButton: "Bezig…",
        previewEmpty: "Geen retired objecten gevonden in deze scope.",
        resultHeading: "Te verwijderen — bevestig om door te gaan:",
        conceptsHeading: "Concepten ({{count}})",
        relationsHeading: "Relaties ({{count}})",
        diagramsHeading: "Diagrammen ({{count}})",
        cascadeHeading: "Cascade-afhankelijkheden (worden óók verwijderd):",
        cascadeRelations:
          "{{count}} relaties naar retired concepten (geen «Retired» zelf, maar verliezen hun endpoint)",
        cascadeViewState: "{{entries}} viewState-entries op {{diagrams}} diagrammen",
        cancelButton: "Annuleren",
        confirmButton: "Permanent verwijderen",
        confirmDialog:
          "Dit tombstoned {{concepts}} concepten en {{relations}} relaties, verwijdert {{diagrams}} diagrammen definitief, en stript {{viewstate}} viewState-entries. Doorgaan?",
        cleaningButton: "Bezig…",
        cleanupDone:
          "Klaar — {{concepts}} concepten en {{relations}} relaties getombstoned, {{diagrams}} diagrammen verwijderd, {{viewstate}} viewState-entries opgeschoond.",
      },
    },
    superAdmin: {
      navAria: "Onderdelen van het installatiebeheer",
      navGroupThis: "Deze workspace",
      navGroupAccess: "Toegang",
      navGroupInstall: "Installatie",
      navThisWorkspace: "Naam en toegang",
      thisWorkspaceIntro:
        "De naam van de workspace waarin je nu werkt, en een extra wachtwoord voor super admins die hierheen wisselen.",
      adminsIntro:
        "Wie hier staat, beheert de hele installatie: workspaces, mail, AI en achtergrondtaken. Er blijft altijd minstens één over.",
      workspacesIntro:
        "Maak een workspace aan, leeg of met het voorbeeldmodel, of archiveer, verwijder en zet er een terug.",
      globalMailIntro:
        "De terugval voor elke workspace zonder eigen mailinstelling, en de afzender van de inlogcodes.",
      statusSet: "Ingesteld",
      statusNotSet: "Niet ingesteld",
      passwordSaved: "Wachtwoord opgeslagen.",
      passwordCleared: "Wachtwoord gewist.",
      you: "Jij",
      current: "Huidig",
      needsPassword: "Wachtwoord",
      addAdminLabel: "Super admin toevoegen",
      intro:
        "Als super admin kun je tijdelijk (max 1 uur) inwisselen naar elke workspace om te helpen met inrichten of problemen — je wordt geen lid, de toegang verloopt automatisch.",
      tabMasterPassword: "Master-wachtwoord",
      tabAdmins: "Super admins",
      tabSwitch: "Wissel workspace",
      tabCronJobs: "Cron jobs",
      tabLegacySnapshots: "Oude snapshots",
      tabWorkspaces: "Workspaces",
      workspacesNewHeading: "Nieuwe workspace",
      workspacesName: "Naam",
      workspacesLanguage: "Standaardtaal",
      workspacesAdmin: "Beheerder (e-mail)",
      workspacesCreate: "Workspace aanmaken",
      workspacesCreated: "Workspace '{{name}}' aangemaakt; {{email}} is beheerder.",
      workspacesOpen: "Openen",
      languageEn: "Engels",
      languageNl: "Nederlands",
      exampleHeading: "Voorbeeld-workspace",
      exampleIntro:
        "Maakt een nieuwe workspace met het model van Meridiaan Bank: een fictieve bank met processen, capabilities, applicaties, een Business Model Canvas, C4-diagrammen, risico's en beheersmaatregelen, een roadmap en een conceptmodel. De handleiding gebruikt het als doorlopend voorbeeld. Jij wordt er beheerder van.",
      exampleName: "Meridiaan Bank (voorbeeld)",
      exampleButton: "Voorbeeld-workspace maken",
      exampleBusy: "Voorbeeld-workspace wordt gemaakt…",
      archiveHeading: "Archiveren, verwijderen en terugzetten",
      archiveIntro:
        "Een archief is een volledige kopie van een workspace: workpackages, plateaus, folders, objecten, diagrammen, teams, leden en rechten. Niet mee: snapshots, API-tokens en het mailwachtwoord van de workspace. Je zet een archief terug in deze of een andere installatie, zolang de workspace daar niet meer bestaat.",
      archiveDownload: "Archief downloaden",
      archiveSaved: "Archief van '{{name}}' bewaard als {{file}} ({{rows}} rijen).",
      deleteButton: "Verwijderen…",
      deleteHeading: "Workspace '{{name}}' verwijderen",
      deleteWarning:
        "Dit verwijdert de workspace definitief, met alle workpackages, branches, snapshots en leden. Alleen het archief dat je eerst downloadt, kan hem terugbrengen.",
      deleteArchived: "Archief gedownload",
      deleteConfirm: "Typ '{{name}}' ter bevestiging",
      deleteFinal: "Workspace verwijderen",
      deleteDone: "Workspace '{{name}}' verwijderd.",
      cancel: "Annuleren",
      restoreHeading: "Archief terugzetten",
      restoreIntro:
        "Kies een archiefbestand. Het komt terug als dezelfde workspace, met dezelfde id's, zodat links en AI-koppelingen blijven werken. Kan niet zolang die workspace nog bestaat; voor een kopie gebruik je Export / Import per workpackage.",
      restoreSummary:
        "Workspace '{{name}}', gearchiveerd {{date}}: {{rows}} rijen in {{tables}} tabellen.",
      restoreButton: "Terugzetten",
      restoreDone:
        "Workspace '{{name}}' teruggezet. Had hij een eigen mailinstelling, vul dan het wachtwoord opnieuw in.",
      restoreMismatch: "Workspace '{{name}}' teruggezet, maar aantallen wijken af: {{tables}}.",
      progress_download: "Downloaden",
      progress_rows: "Rijen terugzetten",
      progress_links: "Verwijzingen terugzetten",
      progress_finish: "Controleren",
      exampleIncomplete:
        "De voorbeeld-workspace is aangemaakt, maar {{count}} onderdelen konden niet worden geïmporteerd. Zie het Worker-log.",
      exampleCreated:
        "Workspace '{{name}}' aangemaakt met {{concepts}} objecten, {{relations}} relaties en {{diagrams}} diagrammen.",
      legacySnapshots: {
        colDate: "Gemaakt",
        colScope: "Bereik",
        colLabel: "Label",
        intro:
          "Snapshots van vóór de snapshot-punten (formaat 1) kunnen niet veilig terug als ze een branch betreffen. Hier ruim je ze in alle workspaces op, samen met hun bestanden. Bestanden onder snapshots/ zonder snapshot erbij gaan ook weg; niets anders in de bucket wordt aangeraakt.",
        summary: "{{snapshots}} oude snapshot(s) en {{files}} weesbestand(en).",
        empty: "Er zijn geen oude snapshots en geen weesbestanden meer.",
        purge: "Alles hierboven verwijderen",
        confirm:
          "{{snapshots}} oude snapshot(s) en {{files}} weesbestand(en) definitief verwijderen, in alle workspaces? Dit kan niet ongedaan worden gemaakt.",
        done: "{{snapshots}} snapshot(s) en {{files}} bestand(en) verwijderd.",
      },
      cronJobs: {
        disabledPill: "Uitgeschakeld",
        running: "Bezig",
        triggerCron: "Gepland",
        triggerManual: "Handmatig",
        statusSuccess: "Geslaagd",
        statusError: "Mislukt",
        intro:
          "Cloudflare's cron-trigger vuurt elk uur; deze instellingen bepalen of een job op die tick daadwerkelijk draait. Tijden worden getoond in Amsterdam-tijd en onderwater opgeslagen als UTC.",
        jobMitre: "MITRE CWE-sync",
        jobGc: "Orphan-GC",
        hourLabel: "Uur",
        tzLabel: "Amsterdam",
        hourUtcTooltip: "{{hourUtc}}:00 UTC",
        everyLabel: "Elke",
        daysLabel: "dagen",
        runNowButton: "Nu draaien",
        showHistory: "Geschiedenis tonen",
        hideHistory: "Geschiedenis verbergen",
        lastRun: "Laatste run: {{when}}",
        neverRun: "Nog nooit gedraaid.",
        noRuns: "Nog geen runs.",
        colSummary: "Samenvatting",
        dispatchedInfo:
          "Gestart — de MITRE CWE-sync draait nu via GitHub Actions (fetch/parse) en meldt zich terug zodra 'ie klaar is. Bekijk de geschiedenis voor de voortgang.",
        possiblyStuck: "Mogelijk vastgelopen",
        possiblyStuckTooltip:
          "Deze run staat al meer dan 30 minuten op 'running' zonder af te ronden — de GitHub Actions-run is mogelijk gecrasht vóórdat 'ie kon terugmelden.",
      },
      passwordHint:
        "Minstens 15 karakters, met een hoofdletter, kleine letter, cijfer en speciaal karakter.",
      currentPasswordLabel: "Huidig wachtwoord",
      newPasswordLabel: "Nieuw wachtwoord",
      setButton: "Instellen",
      changeButton: "Wijzigen",
      clearButton: "Wissen",
      workspaceNameTitle: "Naam van deze workspace",
      workspaceNameHint:
        "Zichtbaar in de header, in de workspace-switcher en in elke exportbestandsnaam. Al gedownloade exports en bestaande snapshot-labels dragen de oude naam en veranderen niet mee.",
      workspaceNameSaved: "Naam opgeslagen.",
      workspacePasswordFor: "Toegangswachtwoord voor '{{name}}'",
      workspacePasswordHint:
        "Extra gate die een super admin nog moet invoeren ná het master-wachtwoord, vóórdat 'ie naar déze workspace wisselt.",
      masterPasswordHint:
        "Beschermt de workspace-lijst bij 'Wissel workspace'. Zonder master-wachtwoord ziet elke super admin die lijst meteen.",
      adminsHeading: "Super-admin e-mailadressen",
      addEmailPlaceholder: "naam@voorbeeld.nl",
      addButton: "Toevoegen",
      removeButton: "Verwijderen",
      removeLastError: "Kan de laatste super admin niet verwijderen.",
      switchMasterPasswordLabel: "Master-wachtwoord",
      switchMasterPasswordPlaceholder: "Voer het master-wachtwoord in",
      switchRevealButton: "Toon workspaces",
      switchWorkspaceAccessLabel: "Toegangswachtwoord van deze workspace",
      switchButton: "Wissel",
      switchingButton: "Bezig…",
      switchDone: "Gewisseld naar '{{name}}'.",
      incorrectPassword: "Wachtwoord klopt niet.",
      overrideBanner: "⚡ Super-admin: {{name}}",
      overrideBackButton: "↩ Terug naar mijn workspaces",
    },
  },
  textPane: {
    title: "Onderwater venster",
    openButton: "▲ Onderwater venster",
    openHint: "Onderwater venster openen",
    hideButton: "▼ Verberg",
    hideHint: "Onderwater venster verbergen",
    variantSelectorLabel: "Onderwater venster:",
    variantTextLegacy: "Tekst",
    variantGrid: "Tabel",
    parseErrors_one: "{{count}} parsefout",
    parseErrors_other: "{{count}} parsefouten",
    errorLine: "regel {{line}}: {{message}}",
    preview: {
      hideTitle: "Live preview verbergen",
      showTitle: "Live preview tonen (Mermaid client-side, PlantUML via Kroki)",
      on: "👁 Preview aan",
      off: "👁 Preview",
      header: "Live preview ({{notation}})",
      rendering: "renderen…",
      resetTitle: "100% (natuurlijke grootte)",
      fitTitle: "Aanpassen aan pane (passend maken)",
      empty: "Nog geen preview — typ iets in de editor of activeer een diagram.",
      unexpectedContentType: "Onverwacht content-type: {{contentType}}",
      unknownError: "Onbekende fout tijdens preview-render.",
    },
    perInstance: {
      onTitle:
        "Per-instance modus aan — één regel per visuele instance. Niet-Archi-conform, kroki-render mogelijk minder accuraat.",
      offTitle:
        "Per-instance modus uit — één regel per concept-id (logical view, ArchiMate-conform).",
      on: "🧬 Per-instance aan",
      off: "🧬 Per-instance",
    },
    search: {
      title: "Zoek in tekst (Cmd/Ctrl+F)",
      aria: "Zoek in tekst",
    },
    pin: {
      pinnedTitle: "Vastgepind — pane blijft open na refresh. Klik om los te maken.",
      unpinnedTitle: "Vastpinnen — pane blijft open na refresh.",
    },
    lineType: {
      label: "Lijn:",
      title:
        "PlantUML lijn-routing — wissel om te zien welke layout het beste werkt voor dit diagram",
      curved: "Curved",
      polyline: "Polyline",
      ortho: "Orthogonaal",
    },
    copy: {
      title: "Kopieer tekst naar klembord",
      label: "Kopieer",
      copied: "✓ Gekopieerd",
      labelLower: "kopieer",
      copiedLower: "✓ gekopieerd",
    },
  },
  gridPane: {
    statusBar:
      "Tabel (nieuw) — {{rows}} rijen — rev #{{revision}} — dubbelklik op kolom B om naam/label te bewerken — Pijl ↑↓ / Shift+Pijl voor toetsenbord-selectie",
    searchPlaceholder: "Zoeken in tabel…",
    searchAriaLabel: "Zoeken in tabel",
    noActiveDiagram: "Geen actief diagram of workspace",
    parseErrors_one: "{{count}} parse-fout: {{errors}}",
    parseErrors_other: "{{count}} parse-fouten: {{errors}}",
    selectedCount: "{{n}} geselecteerd",
    selectionKeyHint:
      "Shift-klik = range, Cmd/Ctrl-klik = toggle, DEL = verwijder, rechtermuis = menu",
    columns: {
      b: "B — Tekstueel",
      c: "C — Pos / Source",
      d: "D — Target-handle",
      e: "E — Stereotypes",
      f: "F — Anker",
    },
    titles: {
      editName: "Dubbelklik om naam te bewerken",
      editLabel: "Dubbelklik om label te bewerken",
      editPosition: "Dubbelklik om positie te bewerken (x, y)",
      pickSourceHandle: "Dubbelklik om source-handle te kiezen",
      pickTargetHandle: "Dubbelklik om target-handle te kiezen",
      assignStereotypes: "Dubbelklik om stereotypes toe te kennen",
      editStereotypes: "Dubbelklik om stereotypes te bewerken — {{n}} actief",
    },
    noRows: "Geen rijen — selecteer een diagram of voeg eerst een object toe.",
    menu: {
      pasteHere: "Plakken hier ({{n}})",
      cancelMove: "Verplaatsen annuleren",
      insertRow: "Regel invoegen (Alt+N)",
      showOnCanvas: "Toon op canvas",
      move: "Verplaatsen",
      delete: "Verwijderen ({{n}})",
      deselect: "Deselecteren",
      removeFromDiagram: "Verwijderen ({{n}})",
      deleteFromModel: "Opruimen… ({{n}})",
    },
    stereotypeModal: {
      titlePrefix: "Stereotypes voor",
      noneAvailable: "Geen stereotypes beschikbaar voor dit type.",
      clear: "Wissen",
      cancel: "Annuleren",
      saving: "Opslaan…",
      save: "Opslaan",
    },
  },
  parentDelete: {
    title: "Objecten verwijderd op de bovenliggende laag",
    description:
      "Deze objecten zijn op de bovenliggende laag verwijderd, maar deze branch gebruikt ze nog in eigen relaties. Kies per object wat er moet gebeuren.",
    usedIn: "Gebruikt in {{count}} branch-relatie(s)",
    keep: "Behouden als branch-object",
    accept: "Verwijderen",
    later: "Later",
  },
  homonymLink: {
    title: "Mogelijk hetzelfde object",
    description:
      "Deze objecten op deze branch hebben dezelfde naam en type als een object op de bovenliggende laag, maar zijn niet gekoppeld. Koppel ze om ze als één object te behandelen (de branch-versie blijft volledig behouden), of negeer als het écht twee verschillende dingen zijn.",
    matchHint: "Zelfde naam en type als een object op de bovenliggende laag.",
    link: "Koppelen",
    dismiss: "Negeren",
    later: "Later",
  },
  plateauDiff: {
    title: "Plateau — diagrammen t.o.v. het vorige plateau",
    comparedTo: "t.o.v. {{plateau}}",
    statusAdded: "Nieuw",
    statusChanged: "Gewijzigd",
    statusDeleted: "Verwijderd",
    statusNeutral: "Ongewijzigd",
    cardHint: "Klik = selecteren · dubbelklik = openen",
    detailTitle: "Wijzigingen op dit diagram",
    elementChanges: "{{count}} wijziging(en)",
    noElementChanges: "Geen element-wijzigingen op dit diagram.",
    deletedDetail: "Dit diagram is verwijderd t.o.v. het vorige plateau.",
    loading: "Diagrammen laden…",
    error: "Kon de diagram-diff niet laden.",
    empty: "Geen diagrammen op dit plateau.",
  },
  sharp: {
    levelArea: "procesgebied",
    levelBusiness: "bedrijfsproces",
    levelSub: "subproces",
    nestLevelInverted:
      "Let op: je nest een {{child}} in een {{parent}}. Dat keert de niveaus om — Sharp gaat van procesgebied naar bedrijfsproces naar subproces. De aggregatie is aangelegd; draai 'm om als dit niet de bedoeling was.",
  },
  swimlane: {
    resultSymbol: "Procesresultaat",
    legendFlow: "Stroom — gestreept, met pijl",
    legendTriggering: "Opvolging — doorgetrokken, met pijl",
    stepDelays: "Deze stap houdt het werk op",
    laneHeightHint: "Sleep om de baan hoger of lager te maken",
    delay: "Deze overdracht kost tijd — {{value}}",
    titleHint:
      "De naam van dit diagram — klik voor de eigenschappen (zoals het tijdstip), dubbelklik om te hernoemen",
    newLaneZoneTop: "Sleep hier een uitvoerder voor een baan bovenaan",
    newLaneZone: "Sleep hier een uitvoerder voor een nieuwe baan, of een stap om 'm los te maken",
    arrange: "Schik de stappen",
    arrangeHint: "Zet elke stap in de baan van z’n uitvoerder en op de plek die de stroom ’m geeft",
    connectHint: "Trek naar een andere stap om er een stroom tussen te leggen",
    resizeHint: "Sleep om de kaart groter of kleiner te maken",
    noFlowBetween: "Tussen deze twee kan op dit diagram geen stroom lopen.",
    flowRule: {
      mergeQuestion: "Deze stap heeft al een inkomende stroom. Hoe komen de twee samen?",
      splitQuestion: "Deze stap heeft al een uitgaande stroom. Hoe splitst het werk?",
      xor: "XOR — exclusief",
      and: "AND — parallel",
      of: "OR — één of meer",
      samen: {
        xor: "Het werk komt langs precies één van de wegen binnen",
        and: "Wacht tot het werk langs alle wegen binnen is",
        of: "Het werk komt langs één of meer wegen binnen",
      },
      splits: {
        xor: "Het werk gaat langs precies één van de wegen verder",
        and: "Het werk gaat langs alle wegen tegelijk verder",
        of: "Het werk gaat langs één of meer wegen verder",
      },
      cancel: "Annuleren",
      both: "Deze stroom zou twee regels tegelijk breken: de bronstap heeft al een uitgang en de doelstap al een ingang. Zet eerst zelf een vertakking of samenkomst.",
      violation:
        "Deze stap heeft meer dan één inkomende of uitgaande stroom. Samenkomen en splitsen horen via een XOR, AND of OR te lopen, zodat de betekenis op het diagram staat. Alleen een beslisstap mag meerdere uitgaande takken hebben.",
      shouldDecide:
        "Na deze stap volgt een XOR, dus deze stap kiest welke tak het wordt. Geef 'm het stereotype Beslisstap in het attributenpaneel.",
    },
    branch: {
      xor: "Vertakking: precies één pad",
      and: "Vertakking: alle paden",
      of: "Vertakking: één of meer paden",
      samen: "Samenvoeging: de wegen komen hier bij elkaar",
    },
    laneOwnerHint:
      "Dubbelklik om de uitvoerder te bewerken. Sleep er een andere uitvoerder op om de baan over te dragen — de stappen verhuizen mee.",
    unassigned: "Nog niet toegewezen",
    unassignedHint: "Sleep een stap naar een baan om vast te leggen wie 'm uitvoert",
    empty: "Nog geen stappen op dit diagram. Sleep een stap uit het palet.",
    noLanes:
      "Nog geen banen. Sleep een uitvoerder uit het palet — een rol, systeem, machine of wachtplek.",
    handoffs_one: "{{count}} overdracht",
    handoffs_other: "{{count}} overdrachten",
    steps_one: "{{count}} stap",
    steps_other: "{{count}} stappen",
    lanePool: "Onder {{name}}",
    legendHandoff: "Overdracht — het werk wisselt van baan",
    legendSequence: "Opvolging — binnen dezelfde baan",
    unnamed: "(naamloos)",
    svgTitle: {
      handoff: "overdracht",
      sequence: "opvolging",
      flows: "Stromen tussen stappen",
    },
  },
  glossary: {
    title: "Attribuuttypes",
    count: "{{count}} attribuuttype(s)",
    add: "Toevoegen",
    edit: "Bewerken",
    delete: "Verwijderen",
    colName: "Naam",
    colDefinition: "Definitie",
    empty: "Nog geen attribuuttypes. Klik op Toevoegen.",
    unnamed: "(naamloos)",
    readOnly: "Alleen-lezen — dit workpackage heeft geen schrijfrechten op deze folder",
    addTitle: "Nieuw attribuuttype",
    editTitle: "Attribuuttype bewerken",
    name: "Naam",
    nameNl: "Naam (NL)",
    nameEn: "Naam (EN)",
    defNl: "Definitie (NL)",
    defEn: "Definitie (EN)",
    cancel: "Annuleren",
    save: "Opslaan",
    confirmDelete: "Attribuuttype '{{name}}' verwijderen?",
  },
  roadmap: {
    aiBadge: "AI",
    aiBadgeTitle:
      "Door een AI aangemaakt via de MCP. Hier mag de AI zelf snapshots terugzetten en het plateau weggooien. Wat de AI deed draait Ctrl+Z niet terug; gebruik daarvoor een snapshot.",
    title: "Roadmap — plateaus in de tijd",
    subtitle:
      "Elke lane is een plateau (versie van de wereld). Schuif de tijd-slider om een plateau actief te maken.",
    now: "nu",
    active: "actief",
    currentSituation: "Huidige situatie",
    switchHint: "Klik = naar dit plateau tijdreizen",
    mergeIntoParent: "⇥ Samenvoegen in {{parent}}",
    mergeHint: "Tijd laten voortschrijden: dit plateau opgaan in het vorige",
    laneHint: "I&M-elementen plaatsen volgt",
    dropHint: "Sleep hier een Werkpakket",
    dropWpOnLane:
      "Sleep een Werkpakket op een plateau. Een Deliverable sleep je op een Werkpakket.",
    dropDeliverableOnWp: "Alleen een Deliverable kun je op een Werkpakket droppen.",
    moveOrCopyDeliverable:
      "Deze deliverable hoort al bij een ander werkpakket. Verplaatsen (oude koppeling vervalt) of ook hier koppelen (kopiëren)?",
    move: "Verplaatsen",
    copy: "Kopiëren",
    cancel: "Annuleren",
    ok: "OK",
    removeFromRoadmap: "Verwijderen",
    hardDelete: "Definitief verwijderen",
    plateau1NoConcept:
      "Dit plateau heeft nog geen plateau-object — plaats op een toekomstig plateau.",
    onlyWpDeliverable: "Alleen Werkpakketten en Deliverables kun je in een plateau plaatsen.",
    unnamed: "(zonder naam)",
    workPackage: "Werkpakket — realiseert dit plateau",
    deliverable: "Deliverable — ontstaat bij dit plateau",
    gaps: "Gaps",
    differences: "Differences",
    addPlateau: "Plateau toevoegen",
    addConfirm: "Toevoegen",
    plateauNamePlaceholder: "Naam van het plateau…",
    timeSlider: "Tijd",
    loading: "Roadmap laden…",
    error: "Kon de roadmap niet laden.",
  },
  roadmapMatrix: {
    title: "Roadmap-matrix",
    subtitle:
      "Evolutie van gekozen elementen over de plateaus. Sleep alleen de zaken van belang erop.",
    now: "Nu",
    elementColumn: "Element",
    notConfiguredTitle: "Nog niet geconfigureerd",
    notConfiguredHint:
      "Kies in het Diagrammen-paneel een Program (= Roadmap) en een concept-type. De kolommen komen dan uit de plateaus van dat Program.",
    loading: "Plateaus laden…",
    error: "Kon de plateaus niet laden.",
    dropHint: "Sleep hier elementen op de matrix",
    unnamed: "(zonder naam)",
    configTitle: "Roadmap-matrix configuratie",
    programLabel: "Program (Roadmap)",
    programChoose: "— kies Program —",
    programNone: "Geen Program in deze workspace. Maak er eerst één (Roadmap-diagram).",
    domainLabel: "Concept-type",
    domainChoose: "— kies type —",
    setupTitle: "Roadmap-matrix aanmaken",
    setupConfirm: "Aanmaken",
    active: "actief",
    dropElementHint: "Sleep hier een element",
    dropTypeMismatch: "Dit element past niet bij het gekozen concept-type van deze matrix.",
    statePlaceholder: "toestand…",
    notInPlateau: "Dit object bestaat niet in dit plateau",
    translating: "vertalen…",
    removeRow: "Verwijder rij van de matrix",
  },
  zoomPan: {
    zoomIn: "Inzoomen",
    zoomOut: "Uitzoomen",
    reset: "Zoom terugzetten naar 100%",
  },
  boxFormat: {
    font: "Lettertype",
    size: "Lettergrootte",
    fontColor: "Tekstkleur",
    fillColor: "Vulkleur",
    align: {
      left: "Links uitlijnen",
      center: "Centreren",
      right: "Rechts uitlijnen",
    },
    vAlign: {
      top: "Boven",
      middle: "Midden",
      bottom: "Onder",
    },
    clear: "Opmaak wissen",
    close: "Sluiten",
  },
  gapDiff: {
    title: "Gap — wijzigingen t.o.v. het vorige plateau",
    tabObjects: "Objecten",
    tabRelations: "Relaties",
    tabReifications: "Reïficaties",
    viewModel: "Model",
    viewTable: "Tabel",
    colField: "Veld",
    colBefore: "Oud",
    colAfter: "Nieuw",
    currentSituation: "Huidige situatie",
    fields: {
      typeId: "Type",
      name: "Naam",
      description: "Beschrijving",
      stereotypes: "Stereotypen",
      source: "Bron",
      target: "Doel",
      label: "Label",
    },
    valueYes: "Ja",
    valueNo: "Nee",
    statusAdded: "Toegevoegd",
    statusChanged: "Gewijzigd",
    statusDeleted: "Verwijderd",
    empty: "Geen wijzigingen t.o.v. het vorige plateau.",
    loading: "Diff laden…",
    error: "Kon de diff niet laden.",
    reificationsHint: "Reïficaties volgen zodra het reïficatie-primitief is gebouwd.",
    onMain: "Dit is de hoofdversie (main) — geen voorganger om mee te vergelijken.",
  },
  typeExplorer: {
    title: "Typeverkenner",
    launch: "Typeverkenner",
    launchDesc: "Overzicht van alle typen en concepten in de actieve branch.",
    close: "Sluiten",
    empty: "Geen concepten voor deze filters.",
    count: "{{count}} concepten",
    search: "Zoek op naam…",
    filters: "Filters",
    clearFilters: "Wissen",
    noStereotypes: "(geen stereotypes)",
    jumpHint: "Klik om naar een diagram te springen",
    notOnDiagram: "Staat op geen enkel diagram",
    col: {
      name: "Naam",
      type: "Type",
      stereotype: "Stereotype",
      layer: "Laag",
      diagrams: "# diagrammen",
      lastEdit: "Laatst gewijzigd",
    },
  },
  subStereotype: {
    title: "Wat voor {{base}}?",
    hint: "Kies een specifieker type, of laat 'm generiek.",
    generic: "{{base}} (generiek)",
    cancel: "Annuleren",
    confirm: "Kiezen",
  },
  merge: {
    title: "'{{source}}' samenvoegen in '{{target}}'",
    titleLoading: "'{{source}}' samenvoegen",
    loading: "Proefrun wordt berekend…",
    intro:
      "De inhoud van '{{source}}' gaat op in '{{target}}'. '{{source}}' blijft als geschiedenis bestaan en is daarna niet meer te bewerken.",
    added: "Erbij",
    changed: "Gewijzigd",
    deleted: "Weg",
    kind: {
      concept: "Objecten",
      relation: "Relaties",
      diagram: "Diagrammen",
    },
    children: "Krijgen '{{target}}' als ouder: {{list}}.",
    field: {
      name_json: "Naam",
      description_json: "Beschrijving",
      label_json: "Label",
      attributes_json: "Attribuut {{key}}",
      stereotypes_json: "Stereotype {{key}}",
      tags_json: "Tag {{key}}",
      alt_labels_json: "Alternatieve namen",
      type_id: "Type",
      parent_id: "Ouder-object",
      source_concept_id: "Bron",
      target_concept_id: "Doel",
      name: "Naam",
      notation_pack: "Notatie",
      view_kind: "Soort diagram",
    },
    conflictsTitle: "Conflicten",
    noConflicts: "Geen conflicten.",
    conflict: {
      deletedOnTarget: "'{{source}}' wijzigde dit, '{{target}}' verwijderde het.",
      deletedOnTarget_source: "Terughalen met de versie van de branch",
      deletedOnTarget_target: "Verwijderd laten",
      changedOnTarget: "'{{source}}' verwijderde dit, '{{target}}' wijzigde het daarna.",
      changedOnTarget_source: "Verwijderen",
      changedOnTarget_target: "Behouden",
    },
    propagationTitle: "Andere branches",
    propagation: {
      updated: "{{branch}}: '{{name}}' neemt {{taken}} veld(en) over en houdt {{kept}} eigen",
      rebased: "{{branch}}: '{{name}}' houdt z'n eigen waarden",
      deletedOnParent:
        "{{branch}}: '{{name}}' verdwijnt, maar heeft daar nog een eigen kopie; de branch krijgt de vraag of die nog in gebruik is",
      noBase: "{{branch}}: '{{name}}' is te oud om bij te werken; kijk er zelf naar",
    },
    duplicates_one: "Eén object stond twee keer op de branch; de jongste versie gaat mee.",
    duplicates_other:
      "{{count}} objecten stonden twee keer op de branch; de jongste versie gaat mee.",
    safetyNote:
      "Vooraf wordt een herstelpunt gemaakt. Wie dat terugzet (Snapshots), draait de samenvoeging terug.",
    cancel: "Annuleren",
    confirm: "Samenvoegen",
    running: "Bezig met samenvoegen…",
    cancelled: "Samenvoegen afgeblazen.",
    operationLabel: "'{{source}}' samenvoegen in '{{target}}'",
    done: "'{{source}}' is samengevoegd in '{{target}}'. Het herstelpunt staat bij de snapshots.",
  },
  operations: {
    kind: {
      import: "Import",
      restore: "Terugzetten",
      merge: "Samenvoegen",
    },
    preview: {
      title: {
        import: "Dit gaat de import doen",
        restore: "Dit gaat het terugzetten doen",
        merge: "Dit gaat het samenvoegen doen",
      },
      removed_one: "1 object verdwijnt",
      removed_other: "{{count}} objecten verdwijnen",
      overwritten_one: "1 bestaand object wordt overschreven",
      overwritten_other: "{{count}} bestaande objecten worden overschreven",
      diagrams_one: "1 diagram gaat op de schop",
      diagrams_other: "{{count}} diagrammen gaan op de schop",
      diagramAction: {
        update: "aangepast",
        insert: "nieuw",
        remove: "verdwijnt",
      },
      created_one: "1 object komt erbij",
      created_other: "{{count}} objecten komen erbij",
      reused_one: "1 object blijft ongemoeid",
      reused_other: "{{count}} objecten blijven ongemoeid",
      nothingOverwritten: "Niets bestaands wordt overschreven.",
      noneListed: "Geen namen om te tonen.",
      truncated: "Niet alle namen staan in de lijst — de aantallen kloppen wel.",
      confirm: "Doorgaan",
      cancel: "Annuleren",
      close: "Sluiten",
      show: "Wat verandert er?",
    },
    countdown: "{{kind}} door {{who}} begint over {{time}}",
    quietNow: "{{kind}} begint over {{time}} — rond je werk af",
    dueNow: "{{kind}} kan beginnen — {{who}} start 'm",
    running: "{{kind}} is bezig — even niets bewerken",
    impactOverwritten_one: "overschrijft 1 bestaand object",
    impactOverwritten_other: "overschrijft {{count}} bestaande objecten",
    impactRemoved_one: "1 object verdwijnt",
    impactRemoved_other: "{{count}} objecten verdwijnen",
    keepWorking: "Je kunt gewoon doorwerken en opslaan.",
    awaiting: "Wachten op: {{who}}",
    askedForTime: "Meer tijd gevraagd door: {{who}}",
    ready: "Ik ben klaar, begin maar",
    readyDone: "Je bent klaar",
    needMoreTime: "Ik heb meer tijd nodig",
    startNow: "Nu starten",
    cancel: "Afblazen",
  },
  locks: {
    heldBy: "{{holder}} is dit object aan het bewerken — je kunt het zolang niet wijzigen.",
    heldByOccurrence: "{{holder}} bewerkt dit voorkomen — je kunt het zolang niet wijzigen.",
    heldByBatch: "Er loopt hier een import of herstel — bewerken kan zo weer.",
    lost: "Je bewerkrecht op dit object is vervallen — controleer je wijziging voordat je verder gaat.",
  },
  chat: {
    attachDiagram: "Verwijs naar {{name}}",
    hint: "Enter verstuurt. Ctrl+Enter, Alt+Enter of Shift+Enter maakt een nieuwe regel. Esc sluit. Berichten verdwijnen zodra de app sluit.",
    close: "Sluiten",
    title: "Bericht aan {{email}}",
    unauthorized:
      "Dit diagram is hier niet beschikbaar — mogelijk heb je er geen toegang toe of staat het op een andere branch.",
    empty: "Nog geen berichten. Wat je hier stuurt is niet blijvend.",
    unread: "Ongelezen bericht",
    placeholder: "Typ een bericht…",
    send: "Verstuur",
  },
  presence: {
    workingIn: "Werkt in: {{name}}",
    onlyYou: "Alleen jij bent online",
    youPlusOthers_one: "Jij + {{count}} ander online",
    youPlusOthers_other: "Jij + {{count}} anderen online",
    meLabel: "{{email}} (jij)",
  },
  apiTokens: {
    hideRevoked: "Ingetrokken tokens verbergen",
    showRevoked: "Ingetrokken tokens tonen ({{count}})",
    newTitle: "Nieuw token",
    intro:
      "Met een API-token kan een programma namens jou werken: de MCP-server waarmee Claude modelleert, de desktop- of iPad-app, of een eigen script. Een token heeft nooit meer rechten dan jij zelf.",
    scopeLabel: "Niveau",
    scopes: {
      read: "Lezen",
      model: "Modelleren",
      admin: "Beheer",
    },
    scopeHelp: {
      read: "Alleen bekijken.",
      model: "Bekijken en modelleren: objecten, relaties, diagrammen, branches.",
      admin: "Ook beheer: workpackages, teams, rechten, folders, import en herstel.",
    },
    name: "Naam",
    namePlaceholder: "bijv. Claude op mijn laptop",
    workspace: "Workspace",
    allWorkspaces: "Alle workspaces waar ik lid van ben",
    expiry: "Geldig",
    expiryDays: "{{count}} dagen",
    expiryNever: "Onbeperkt",
    create: "Token aanmaken",
    creating: "Bezig…",
    createdTitle: "Kopieer je token nu",
    createdBody: "Dit is de enige keer dat je het ziet. Bewaar het als een wachtwoord.",
    copy: "Kopiëren",
    copied: "Gekopieerd",
    done: "Klaar",
    listTitle: "Jouw tokens",
    empty: "Je hebt nog geen tokens.",
    colName: "Naam",
    colScope: "Niveau",
    colClient: "Via",
    colLastUsed: "Laatst gebruikt",
    colExpires: "Verloopt",
    never: "nooit",
    revoke: "Intrekken",
    revoked: "ingetrokken",
    revokeConfirm: "Token “{{name}}” intrekken? Wat ermee werkt stopt direct.",
    colAi: "AI schrijft",
    aiPlateauOnly: "alleen AI-plateaus",
    aiAnywhere: "waar het workpackage toestaat",
    aiToggleTitle:
      "Wat deze AI-koppeling mag schrijven. De stand van het workpackage geldt altijd; dit kan alleen verder beperken.",
    mcpTitle: "Claude koppelen via MCP",
    mcpBody:
      "Je hoeft geen token over te typen: start de MCP-server zonder token, dan opent 'ie deze app met een koppelcode en klik je op Toestaan.",
  },
  connect: {
    title: "Koppeling goedkeuren",
    loading: "Aanvraag ophalen…",
    codeLabel: "Koppelcode",
    codeHelp: "Vergelijk deze code met wat de app toont.",
    enterCode: "Voer de koppelcode in die de app toont",
    lookup: "Zoeken",
    asks: "{{client}} wil namens jou ({{email}}) werken.",
    scopeLabel: "Met niveau",
    workspaceLabel: "Beperkt tot workspace",
    anyWorkspace: "Alle workspaces waar je lid van bent",
    aiPlateauOnly: "Alleen op eigen AI-plateaus schrijven",
    aiPlateauOnlyHelp:
      "De AI werkt dan op een eigen plateau op de roadmap en nooit rechtstreeks op main of jouw branches, ook waar het workpackage meer toestaat.",
    approve: "Toestaan",
    deny: "Weigeren",
    approvedTitle: "Gekoppeld",
    approvedBody: "Je kunt dit venster sluiten; de app gaat nu verder.",
    deniedTitle: "Geweigerd",
    deniedBody: "De app krijgt geen toegang.",
    backToEditor: "Naar de editor",
    manageTokens: "Tokens beheren via Instellingen → API-tokens.",
  },
  aiWrite: {
    label: "Wat mag AI hier schrijven",
    none: "Niets — AI mag alleen lezen",
    ai_plateau: "Alleen op een eigen AI-plateau",
    anywhere: "Overal waar de gebruiker mag schrijven",
    help: {
      none: "Een AI (via de MCP-koppeling in Claude) kan in dit workpackage alleen lezen; ook een AI-plateau aanmaken kan niet.",
      ai_plateau:
        "Een AI maakt een eigen plateau op de roadmap en schrijft alleen daar. Main, jullie branches, folders en workpackage-brede zaken blijven dicht. Wat de AI deed zie je in één keer, en overnemen is een bewuste merge.",
      anywhere:
        "Een AI mag schrijven waar de gebruiker zelf mag schrijven, ook op main. Let op: Ctrl+Z in de browser draait AI-wijzigingen niet terug.",
    },
    note: "Geldt alleen voor AI-koppelingen (MCP), niet voor de browser of de beheerapps. Een koppeling kan zelf nog strenger zijn ingesteld; de strengste geldt.",
    saved: "AI-stand opgeslagen.",
  },
  wpSettings: {
    menu: "Workpackage-instellingen…",
    menuDesc: "Naam, beschrijving en wat een AI in dit workpackage mag.",
    title: "Workpackage-instellingen",
    nameLabel: "Naam",
    descriptionLabel: "Beschrijving",
    save: "Opslaan",
    close: "Sluiten",
    saved: "Opgeslagen.",
    readOnly:
      "Je kunt deze instellingen bekijken; wijzigen kan een workspace-admin of een team met schrijfrecht op dit workpackage.",
    baseReadOnly:
      "Het Base-workpackage heeft een vaste naam en beschrijving; alleen de AI-stand is in te stellen.",
    noWorkpackage: "Kies eerst een workpackage.",
    loading: "Laden…",
  },
  importing: {
    readingFile: "Momentje, ik ben het bestand aan het laden…",
    updatingTranslations: "Momentje, ik ben de vertalingen aan het bijwerken…",
    mergingDuplicates: "Momentje, ik ben dubbele objecten aan het samenvoegen…",
    linkingContainers: "Momentje, ik koppel objecten aan hun container…",
  },
  scopePicker: {
    title: "Focus-scope kiezen",
    hint: "↑↓ navigeren, Enter bevestigen, 1-8 direct.",
    current: "huidig",
    scopes: {
      canvas: "Canvas",
      explorer: "Explorer",
      diagramsPanel: "Diagrammen-paneel",
      typePalette: "Type-palette",
      relationsPanel: "Relaties-paneel",
      textPane: "Onderwater venster",
      attributePanel: "Attribuut-paneel",
      toolbar: "Canvas-toolbar",
    },
    short: {
      canvas: "Canvas",
      explorer: "Explorer",
      diagramsPanel: "Diagrammen",
      typePalette: "Type-palette",
      relationsPanel: "Relaties",
      textPane: "Onderwater",
      attributePanel: "Attributen",
      toolbar: "Toolbar",
    },
  },
  help: {
    title: "❓ Gebruikershandleiding",
    versionNote:
      "Versie van de handleiding: ingebakken bij build. Bij gewijzigde documentatie verschijnt de nieuwe versie na een redeploy.",
    appVersion: "Arch-designer {{version}}",
    serverVersion: "server {{version}}",
  },
  auth: {
    gate: {
      authenticating: "Bezig met authenticeren…",
      apiFailed: "Verbinding met API mislukt",
      unexpectedStatus: "API gaf onverwachte status {{status}}",
      networkError: "netwerkfout",
    },
    login: {
      lead: "Modelleer samen in één repository: ArchiMate 4, C4, Sharp en meer. Elk diagram is een weergave op hetzelfde model.",
      emailHeading: "Inloggen",
      emailHint: "We sturen een code van zes cijfers naar dit adres.",
      codeHeading: "Voer je code in",
      codeDelay: "De mail kan een of twee minuten onderweg zijn.",
      codeResent: "Nieuwe code verstuurd.",
      language: "Taal",
      version: "Versie {{version}}",
      emailLabel: "E-mailadres",
      sendCode: "Stuur inlogcode",
      busy: "Bezig…",
      wait: "Wacht {{time}}",
      codeSentTo: "Code verstuurd naar",
      otherAddress: "Ander adres?",
      codeLabel: "6-cijferige code",
      signIn: "Inloggen",
      resendIn: "Stuur opnieuw ({{seconds}}s)",
      resend: "Stuur de code opnieuw",
      tooManyAttempts: "Te veel pogingen. Probeer opnieuw over {{time}}.",
      requestFailed: "Kon code niet aanvragen. Probeer het opnieuw.",
      codeInvalid: "Code is ongeldig of verlopen. Vraag een nieuwe code aan.",
      networkError: "Netwerkfout — probeer het opnieuw.",
      mailNotConfigured:
        "Deze installatie kan nog geen inlogcodes mailen. Een super-admin stelt eerst de mail in onder Instellingen → Workspace → E-mail (globaal).",
    },
    sessionExpiring: {
      messageBefore: "⚠ Je sessie verloopt over ",
      messageAfter: ". Vernieuw nu om niet mid-werkdag uitgelogd te worden.",
      oneDay: "1 dag",
      lessThanADay: "minder dan een dag",
      days: "{{n}} dagen",
      renew: "Vernieuw",
      notNow: "Niet nu",
    },
  },
  repositoryMenu: {
    groupView: "Bekijken",
    groupSnapshots: "Snapshots",
    groupCleanup: "Opschonen",
    groupCleanupNote: "Maakt eerst een snapshot.",
    groupExchange: "Importeren en exporteren",
    button: "Repository",
    glossaryTitle: "Attribuuttypen (glossary)",
    glossaryDesc: "De gedeelde attribuuttypen in een tabel.",
    typeExplorerTitle: "Typeverkenner",
    typeExplorerDesc: "Alle typen en concepten in deze branch.",
    snapshotMakeTitle: "Snapshot maken",
    snapshotMakeDesc: "Legt de huidige stand vast: het workpackage, de branch of de folder.",
    snapshotMade:
      "Snapshot gemaakt: {{concepts}} concepten, {{relations}} relaties, {{diagrams}} diagrammen, {{viewStates}} viewState-entries.",
    snapshotReused: "Er is niets veranderd sinds snapshot '{{label}}' — geen nieuwe gemaakt.",
    restoreStructureIntro:
      "Deze snapshot zet ook de branches eronder terug naar hoe ze toen waren:",
    restoreLater: "Nu niet terug te zetten.",
    restoreNever: "Kan niet meer terug.",
    snapshotCleanup: "Opruimen",
    snapshotCleanupConfirm:
      "Snapshot '{{label}}' kan niet meer teruggezet worden. Definitief verwijderen?",
    restoreBranchRemoved: "• '{{name}}' verdwijnt (bestond toen nog niet)",
    restoreBranchRecreated: "• '{{name}}' komt terug",
    snapshotRestoreTitle: "Snapshot terugzetten…",
    snapshotRestoreDesc: "Kies een eerder herstelpunt van dit workpackage, deze branch of folder.",
    snapshotRestoreModalTitle: "Snapshot terugzetten",
    snapshotRestoreModalEmpty: "Geen snapshots gevonden voor deze scope.",
    snapshotRestoreModalConfirm: "Terugzetten",
    snapshotRestoreModalCancel: "Annuleren",
    snapshotRestored:
      "Snapshot teruggezet: {{concepts}} concepten, {{relations}} relaties, {{diagrams}} diagrammen, {{viewStates}} viewState-entries.",
    snapshotRestoreConfirm:
      "Snapshot '{{label}}' wordt teruggezet binnen de huidige scope. Een veiligheids-snapshot wordt eerst gemaakt. Doorgaan?",
    dedupeTitle: "Dubbele objecten samenvoegen",
    dedupeDesc: "Voegt concepten met dezelfde naam, hetzelfde type en dezelfde stereotypes samen.",
    dedupeConfirm:
      "Alle gelijknamige concepten van hetzelfde type en stereotype-set worden samengevoegd. Eerst wordt een safety-snapshot gemaakt. Doorgaan?",
    dedupeDoneNone: "Geen dubbele concepten gevonden.",
    dedupeDone: "Klaar — {{groups}} groep(en) samengevoegd, {{losers}} duplicaten verwijderd.",
    autoNestTitle: "Nesting herkennen (alle diagrammen)",
    autoNestDesc:
      "Een concept dat binnen een groter kader ligt, krijgt dat kader als ouder. Voor één diagram: Cmd+Shift+F.",
    autoNestConfirm:
      "Voor elk concept zonder parent dat geometrisch binnen een grotere container valt — op alle diagrammen in deze workpackage — wordt de container automatisch als parent gezet. Eerst wordt een safety-snapshot gemaakt. Doorgaan?",
    autoNestDoneNone: "Geen ontbrekende nesting-relaties gevonden.",
    autoNestDone: "Klaar — {{count}} concept(en) gekoppeld op {{diagrams}} diagram(men).",
    linkAttrTitle: "Attributen aan hun concept koppelen",
    linkAttrDesc:
      "Een Sharp-attribuut of -identifier die in een Concept genest is, krijgt dat Concept als eigenaar. Eenmalig, voor bestaande data.",
    linkAttrConfirm:
      "Voor elk Sharp-attribuut/identifier zonder eigenaar dat op een diagram in een Concept genest is, wordt dat Concept als parent_id gezet. Eerst wordt een safety-snapshot gemaakt. Doorgaan?",
    linkAttrDoneNone: "Alle attributen/identifiers waren al gekoppeld.",
    linkAttrDone: "Klaar — {{count}} attribuut/identifier(s) aan hun concept gekoppeld.",
    translateTitle: "Vertalingen aanvullen",
    translateDesc: "Vult de lege NL- of EN-kant van tweetalige velden aan met een vertaling.",
    translateConfirm:
      "Voor alle concepten in deze branch: waar één taalveld (NL of EN) leeg is en de andere gevuld, wordt de vertaling automatisch ingevuld via de translate-API. Eerst wordt een safety-snapshot gemaakt. Doorgaan?",
    translateDone:
      "Klaar — {{filled}} taalveld(en) ingevuld op {{concepts}} concept(en) en {{diagrams}} diagram(men).",
    ameffTitle: "AMEFF importeren…",
    ameffDesc:
      "Voegt de objecten uit een ArchiMate-XML-bestand toe aan deze branch. Maakt eerst een snapshot.",
    ameffPrefix: "AMEFF-import",
    jsonTitle: "JSON importeren…",
    jsonDesc: "Laadt een JSON-export in deze branch. Maakt eerst een snapshot.",
    jsonPrefix: "JSON-import",
    importCancelled: "Import afgeblazen — er is niets gewijzigd.",
    restoreCancelled: "Terugzetten afgeblazen — er is niets gewijzigd.",
    exportAmeffTitle: "Exporteren als AMEFF (.xml)",
    exportAmeffDesc: "De branch waarop je staat, als ArchiMate Open Exchange-bestand.",
    exportJsonTitle: "Exporteren als JSON",
    exportJsonDesc: "De branch waarop je staat, als JSON-bestand voor deze app.",
    exportDone: "'{{filename}}' gedownload ({{size}}).",
    exportSkipped:
      "{{count}} concept(en) niet meegenomen — AMEFF kent geen equivalent voor: {{types}}.",
    exportFailed: "Export mislukt: {{msg}}",
    zeroItems: "0 items",
    unitConcepts: "concepten",
    unitRelations: "relaties",
    unitDiagrams: "diagrammen",
    unitViewStates: "viewState-entries",
    unitFoldersCreated: "folders aangemaakt",
    unitSkippedConcepts: "concept(en) geskipt",
    unitSkippedRelations: "relatie(s) geskipt",
    unitAttentionRelations: "relatie(s) om te controleren",
    unitSkippedDiagrams: "diagram(men) geskipt",
    unitUpdatedConcepts: "concepten bijgewerkt",
    unitUpdatedRelations: "relaties bijgewerkt",
    unitUpdatedDiagrams: "diagrammen bijgewerkt",
    unitReusedConcepts: "concepten hergebruikt",
    unitSuffix: "met [imported]-suffix",
    unknownElements: "onbekende elementtypes",
    unknownRelationships: "onbekende relatietypes",
    snapshotFailed: "Snapshot maken mislukt: {{msg}}. Actie afgebroken.",
    ameffFailed: "AMEFF-import mislukt: {{msg}}",
    jsonFailed: "JSON-import mislukt: {{msg}}",
    translateFailed: "Vertaal-actie liep tegen fouten aan; gedeeltelijk afgemaakt: {{msg}}",
    snapPreDedupe: "Pre-ontdubbel",
    snapPreAutoNest: "Pre-nesting-detectie",
    snapPreLinkAttr: "Pre-attribuut-koppeling",
    snapPreTranslate: "Pre-vertaal-update",
    snapPreAmeff: "Pre-AMEFF-import",
    snapPreJson: "Pre-JSON-import",
  },
  moveToFolder: {
    title_one: "Verplaats {{count}} concept naar folder",
    title_other: "Verplaats {{count}} concepten naar folder",
    mixedClasses:
      "Selectie heeft meerdere type-classes ({{classes}}). Een folder kan maar één type-class hebben. Splits de selectie op en verplaats per class.",
    noFoldersBefore: "Geen folders met type-class",
    noFoldersAfter: "in Base. Maak er eerst een aan via Base-WP → Foldertree.",
    partial: "Gedeeltelijk: {{moved}} verplaatst, {{skipped}} overgeslagen — {{reason}}",
    unknown: "onbekend",
    failed: "Verplaatsen mislukt: {{msg}}",
    confirm: "Verplaatsen",
  },
  moveOutOfFolder: {
    title_one: "Verplaats {{count}} concept uit folder",
    title_other: "Verplaats {{count}} concepten uit folder",
    intro:
      "Concepten verlaten Base en krijgen hun nieuwe thuis in de workpackage die write-recht heeft op deze folder. Het «Reference Object»-stereotype wordt afgehaald.",
    loadingWriteHolder: "Write-houder laden…",
    noWriteHolder:
      "Geen workpackage heeft write-recht op deze folder. Wijs eerst write-toegang toe via",
    settingsPath: "⚙ Instellingen → Workpackages → Folder-autorisaties",
    targetLabel: "Doel-workpackage (auto)",
    failed: "Uit-folder-halen mislukt: {{msg}}",
  },
  askClaude: {
    title: "Vraag Claude",
    privacyNote: "Het diagram wordt naar Claude (Anthropic) verstuurd",
    original: "Origineel",
    result: "Resultaat",
    outputLabel: "Output:",
    outputSvg: "SVG (illustratie)",
    outputJson: "JSON (data)",
    outputPlantuml: "PlantUML (ArchiMate)",
    speedLabel: "Snelheid:",
    effort: {
      low: "Snel",
      medium: "Gebalanceerd",
      high: "Grondig",
    },
    effortHint: {
      low: "Claude denkt kort na: het snelst, voor eenvoudige vragen",
      medium: "Duurt meestal een tot enkele minuten",
      high: "Claude denkt lang na: het langzaamst, voor lastige herontwerpen",
    },
    suggestions: {
      managers: "Maak begrijpelijk voor managers (verberg techniek)",
      business: "Vertaal naar zakelijke business-context",
      customer: "Vereenvoudig voor klantpresentatie",
      mainProcesses: "Toon alleen de hoofdprocessen",
      layerIcons: "Voeg iconen toe per ArchiMate-laag",
    },
    promptPlaceholder: "Wat moet Claude met dit diagram doen?  (Cmd+Enter = verzenden)",
    submit: "Verzend",
    busy: "Bezig…",
    copy: "Kopieer",
    copied: "✓ gekopieerd",
    download: "Download",
    noCleanBlock: "Geen schoon code-blok herkend; ruwe output getoond",
    retryTitle:
      "Stuur dezelfde prompt opnieuw — soms levert Claude bij een retry wel een schoon block",
    retry: "Probeer opnieuw",
    writing: "Claude schrijft… ({{chars}} tekens)",
    thinking: "Claude denkt na…",
    emptyBefore: "Voer links een vraag in en druk op ",
    emptyMiddle: " of klik ",
    errors: {
      emptyBody: "Lege response-body van de worker.",
      providerAborted: "De AI-aanbieder brak het antwoord af.",
      maxTokens:
        "Claude dacht zo lang na dat er geen ruimte meer was voor het antwoord. Probeer een kortere of eenvoudigere vraag, of een kleiner diagram.",
      refusal: "Claude heeft dit verzoek geweigerd. Formuleer de vraag anders.",
      noAnswer: "Claude gaf geen antwoord. Probeer het opnieuw.",
      noAnswerWithReason: "Claude gaf geen antwoord (stopreden: {{reason}}). Probeer het opnieuw.",
      noAuth:
        "Er is geen aanmelding bij een AI-aanbieder ingesteld. Een super-admin stelt die in onder Instellingen → Workspace → AI.",
      dailyLimit: "Daglimiet bereikt. Probeer morgen opnieuw of vraag de admin om verhoging.",
      unexpectedContentType: "Onverwacht content-type: {{type}}",
    },
    email: {
      subject: "Vraag Claude — {{prompt}}",
      subjectDefault: "Vraag Claude — resultaat",
      intro: "Resultaat van je 'Vraag Claude'-verzoek:",
      sent: "✓ Verstuurd naar {{recipient}}",
      noMailConfig:
        "Mail-instellingen ontbreken — een admin moet eerst ⚙ Instellingen → E-mail invullen.",
      buttonTitle: "Verstuur het resultaat als bijlage naar {{email}}",
      notLoggedIn: "Niet ingelogd",
      sending: "Versturen…",
      button: "✉ Mail naar mij",
    },
    preview: {
      alt: "Diagram-preview",
      noDiagram: "Geen actief diagram.",
      noSummary: "(geen JSON-summary beschikbaar)",
      rendering: "Renderen…",
      rerender: "Opnieuw renderen",
      renderKroki: "🖼 Render via Kroki",
      backToSourceTitle: "Terug naar PlantUML-bron",
      backToSource: "↩ Bron",
      renderError: "⚠ Render-fout:",
      noPlantuml: "(geen PlantUML beschikbaar)",
    },
  },
  conceptExplorer: {
    pinnedTitle: "Vastgepind — paneel blijft open na refresh. Klik om los te maken.",
    pinTitle: "Vastpinnen — paneel blijft open na refresh.",
    unpinAria: "Pin verwijderen",
    pinAria: "Pin paneel",
    onlyAllowedTypes: "Alleen types die op huidig diagram passen",
    tags: "Tags",
    noTags: "(geen tags in workspace)",
    noOptions: "(geen opties)",
    noMatches: "Geen concepten gevonden voor deze zoekterm.",
    noAllowed: "Geen concepten van types die op dit diagram zijn toegestaan.",
    empty: "Nog geen concepten in deze workspace.",
    rowTitleOnDiagram: "Klik = selecteren, Cmd/Ctrl/Shift = multi-select, Delete = verwijderen",
    rowTitleDrag:
      "Sleep naar canvas (multi-select sleept alle gekozen concepten). Delete = verwijderen.",
    clearAllFilters: "Wis alle filters",
    clear: "wis",
    usedInTitle: "Gebruikt in: {{names}}\nKlik om naar het eerste diagram te springen",
  },
  history: {
    restoreConfirm:
      "Versie {{version}} terugzetten als huidige? Er wordt een nieuwe versie-rij geschreven; eerdere versies blijven bewaard.",
    restored: "✓ Versie {{version}} hersteld als nieuwe versie {{newVersion}}.",
    titleConcept: "📜 Versie-historie (concept)",
    titleRelation: "📜 Versie-historie (relatie)",
    close: "Sluiten",
    noVersions: "Nog geen versies in de historie.",
    current: "actueel",
    pickVersionHint:
      "Kies een versie in de lijst om de wijzigingen ten opzichte van de huidige versie te zien.",
    restoreButton: "↩ Herstel deze versie",
    diffHeading: "Wat verandert er als je deze versie herstelt",
    noDifferences: "Geen verschillen — deze versie is identiek aan de huidige.",
    colField: "Veld",
    colBecomes: "Wordt (deze versie)",
    colWas: "Was (huidige)",
    showUnchanged: "{{n}} ongewijzigde veld(en) tonen",
    fields: {
      parent: "Parent",
      tags: "Tags",
      deleted: "Verwijderd?",
      source: "Bron",
      target: "Doel",
    },
    valueEmpty: "(leeg)",
    valueNone: "(geen)",
    valueYes: "ja",
    valueNo: "nee",
    reason: {
      create: "Aangemaakt",
      update: "Bijgewerkt",
      restore: "Hersteld uit prullenbak",
      restoreFromVersion: "Versie {{version}} hersteld",
    },
    unknownError: "Onbekende fout",
  },
  insertRow: {
    unnamed: "(zonder naam)",
    tabPlantUml: "PlantUML plakken",
    typeSearchPlaceholder: "Zoek type… (bv. BusinessActor, c4, Concept)",
    noTypesFound: "Geen types gevonden",
    preview: "Voorbeeld",
    previewStereotypeTitle: "Voorbeeld: «{{stereotype}}» op {{type}} ({{layer}}-laag)",
    previewLayerTitle: "Voorbeeld in laag-kleur van {{layer}}",
    pickTypeFirst: "Kies eerst een type",
    namePlaceholder: "Naam (bv. CRM-systeem)",
    cancel: "Annuleren",
    insert: "Invoegen",
    source: "Bron",
    target: "Doel",
    relationType: "Relatie-type",
    pickEndpointsFirst: "Kies eerst bron en doel (bestaand of nieuw).",
    noAllowedRelationTypes:
      "Geen toegestane relatie-types tussen deze twee types volgens de matrix.",
    labelPlaceholder: "Label (optioneel)",
    plantUmlHint:
      "Plak een PlantUML-snippet. De parser maakt nieuwe concepten en relaties aan, en update bestaande met dezelfde alias. Verwijder-gedrag (rijen die niet meer in de tekst staan) gebruiken we hier NIET — dit is een additieve import.",
    plantUmlPlaceholder:
      '@startuml\nrectangle "Klant" as n_klant\nrectangle "CRM" as n_crm\nn_klant --> n_crm : gebruikt\n@enduml',
    imported:
      "Geïmporteerd: {{conceptsCreated}} concepten nieuw, {{conceptsUpdated}} bijgewerkt, {{relationsCreated}} relaties nieuw, {{relationsUpdated}} bijgewerkt.",
    close: "Sluiten",
    busy: "Bezig…",
    import: "Importeren",
    existing: "Bestaand",
    "new": "Nieuw",
    typeSearchShort: "Zoek type…",
    newNamePlaceholder: "Naam {{label}}…",
    notVisible: "(niet zichtbaar)",
    searchPlaceholder: "Zoek {{label}}…",
    noResults: "Geen resultaten",
  },
  diagramTabs: {
    unnamed: "(zonder naam)",
    newTitle: "Nieuw diagram",
    newLabel: "Nieuw",
    menu: {
      closeDiagram: "Sluit diagram",
      closeOthers: "Sluit alle diagrammen behalve het geselecteerde",
      closeAll: "Sluit alle diagrammen",
    },
    askClaude: "✨ Vraag Claude",
    askClaudeTitle: "Stuur dit diagram naar Claude voor een vereenvoudiging of herontwerp (F9)",
    export: {
      title: "Exporteer dit diagram",
      svgFailed: "SVG-export mislukt.",
      pngFailed: "PNG-export mislukt.",
    },
    tabTitle: "Klik = activeren, dubbelklik = hernoemen, rechtermuisklik = tab-acties",
    closeTabTitle: "Sluit tab (diagram blijft bestaan)",
    closeTab: "Sluit tab",
    groups: {
      archimate: "ArchiMate",
      riskSecurity: "Risico en beveiliging",
      sharp: "Sharp-modellering",
      c4: "C4-modellering",
      bmc: "Business Model Canvas",
      analytics: "Analyse-views",
      roadmap: "Roadmap & tijdreizen",
    },
    create: {
      namePlaceholder: "Naam",
      groupTitle: "Groepering",
      typeTitle: "Type diagram",
    },
  },
  diagramsPanel: {
    pin: {
      pinnedTitle: "Vastgepind — paneel blijft open na refresh. Klik om los te maken.",
      unpinnedTitle: "Vastpinnen — paneel blijft open na refresh.",
      unpinAria: "Pin verwijderen",
      pinAria: "Pin paneel",
    },
    newPrompt: "Naam van het nieuwe diagram?",
    newTitle: "Nieuw diagram met type 'Vrij'",
    newButton: "+ Nieuw",
    empty: "Nog geen diagrammen.",
    lastDiagramAlert: "Het laatste diagram kan niet worden verwijderd.",
    lastDiagramTitle: "Het laatste diagram kan niet worden verwijderd",
    confirmDeleteMany: "{{n}} diagrammen definitief verwijderen?",
    confirmDeleteOnePermanent: "Diagram '{{name}}' definitief verwijderen?",
    confirmDeleteOne: "Diagram '{{name}}' verwijderen?",
    rowTitle: "Klik = openen, Cmd/Ctrl/Shift = multi-select, Delete = verwijderen",
    tabOpen: "Tab open",
    tabClosed: "Tab gesloten",
    unnamed: "(zonder naam)",
    unknownViewKind: "{{id}} (onbekend)",
    deleteButton: "Verwijder diagram",
    translating: "vertalen…",
    properties: {
      hide: "Eigenschappen verbergen",
      show: "Eigenschappen tonen",
      label: "Eigenschappen",
      nameNl: "Naam (NL)",
      nameEn: "Naam (EN)",
      descriptionNl: "Beschrijving (NL)",
      descriptionEn: "Description (EN)",
      type: "Type",
      descriptionPlaceholder: "Beschrijving — verschijnt als `title` in PlantUML",
    },
    heatMap: {
      title: "Heat-map configuratie",
      target: "Doel-(sub)type",
      choose: "— kies —",
      vertical: "Verticale as",
      horizontal: "Horizontale as",
      chooseEnum: "— kies enum-attribuut —",
      noEnumAttrs: "Dit (sub)type heeft geen enum-attributen.",
    },
  },
  relationsPanel: {
    direction: {
      from: "VAN",
      fromTitle: "Toon relaties die vertrekken vanuit het concept",
      to: "NAAR",
      toTitle: "Toon relaties waarvan het concept het eindpunt is",
    },
    searchPlaceholder: "Zoek concept op naam…",
    empty: {
      noMatch: "Geen concepten gevonden voor deze zoekterm.",
      noOutgoing: "Geen concepten met uitgaande relaties.",
      noIncoming: "Geen concepten met inkomende relaties.",
    },
    unnamed: "(zonder naam)",
    conceptRowTitle: "Klik = selecteren + in/uitklappen",
    occurrences: {
      collapse: "Diagram-voorkomens inklappen",
      expand: "Diagram-voorkomens uitklappen",
      toggleTitle: "Toon diagrammen waar deze relatie op staat",
      none: "Niet op een diagram geplaatst",
    },
    confirmDeleteMany: "{{n}} relaties definitief verwijderen?",
    confirmDeleteOne: "Relatie '{{type}}'{{label}} → [{{other}}] definitief verwijderen?",
    orphanTitle:
      "Verweesde relatie — wijst naar een onbekend concept. Klik + Delete om op te ruimen.",
    rowTitle:
      "Klik om te selecteren. Sleep naar canvas om op dit diagram te plaatsen. Delete = verwijderen uit de workspace.",
  },
  palette: {
    title: "Type palette",
    expandAll: "Alles uitklappen",
    collapseAll: "Alles inklappen",
    relationHint: "Verbind twee concepten op het canvas en kies dan dit type uit het relatie-menu.",
    layers: {
      strategy: "Strategie",
      common: "Generiek",
      business: "Bedrijf",
      application: "Applicatie",
      technology: "Technologie",
      physical: "Fysiek",
      implementationMigration: "I&M (roadmap)",
      motivation: "Motivatie",
      composite: "Composiet",
    },
  },
  cascadeConfirm: {
    blockedByFacet: "'{{name}}' kan niet opgeruimd worden — in gebruik als facet-referentie door:",
    removeFacetsFirst: "Verwijder eerst de facet-koppeling(en) bij die concepten.",
    object: "Object",
    titleRelations_one: "{{count}} relatie opruimen (uit het model)?",
    titleRelations_other: "{{count}} relaties opruimen (uit het model)?",
    titleOne: "{{kind}} '{{name}}' opruimen (uit het model)?",
    titleMany_one: "{{count}} concept opruimen (uit het model)?",
    titleMany_other: "{{count}} concepten opruimen (uit het model)?",
    relationsGo_one: "→ {{count}} relatie verdwijnt mee.",
    relationsGo_other: "→ {{count}} relaties verdwijnen mee.",
    standaloneGo_one: "→ {{count}} los geselecteerde relatie wordt ook opgeruimd.",
    standaloneGo_other: "→ {{count}} los geselecteerde relaties worden ook opgeruimd.",
    onDiagrams_one: "→ Aanwezig in {{count}} diagram: {{list}}",
    onDiagrams_other: "→ Aanwezig in {{count}} diagrammen: {{list}}",
    previewFailed: "(Cascade-preview kon voor minstens één concept niet opgehaald worden.)",
    toTrash: "Opgeruimde objecten en relaties komen in de prullenbak; daar zet je ze terug.",
    ok: "Opruimen",
  },
} as const;
